{
  "nav": {
    "dashboard": "Dashboard",
    "teacherDashboard": "Dozenten-Dashboard",
    "projects": "Projekte",
    "fairQuote": "Schnellangebot",
    "exitFairQuote": "Schnellangebot verlassen",
    "calendar": "Kalender",
    "products": "Produkte",
    "colors": "Farben",
    "company": "Unternehmen",
    "contacts": "Kontakte",
    "applicatorProfiles": "Verarbeiter",
    "courses": "Kurse",
    "certifications": "Zertifizierungen",
    "certificationDefinitions": "Zertifizierungsdefinitionen",
    "userManagement": "Benutzerverwaltung",
    "switchEntity": "Entität wechseln",
    "entities": "Entitäten",
    "staff": "Personal",
    "overview": "Übersicht",
    "sections": {
      "projects": "Projekte",
      "shop": "Shop",
      "learning": "Schulung",
      "admin": "Verwaltung",
      "entity": "Entität"
    }
  },
  "materialTracking": {
    "title": "Materialbestellung",
    "status": {
      "Draft": "Zu bestellen",
      "Ordered": "Bestellt",
      "PartiallyDelivered": "Teillieferung",
      "Delivered": "Geliefert"
    },
    "statusLate": "Lieferverzug",
    "late": "VERSPÄTET",
    "markOrdered": "Als bestellt markieren",
    "markOrderedTitle": "Bestellung bestätigen",
    "markOrderedHint": "Erfassen Sie, dass das Material bestellt wurde. Optional können Sie ein geschätztes Lieferdatum angeben.",
    "estimatedDelivery": "Voraussichtliches Lieferdatum",
    "estimatedDeliveryPlaceholder": "Datum wählen",
    "orderedOn": "Bestellt am",
    "validateDelivery": "Lieferung bestätigen",
    "addDeliveryTitle": "Lieferung erfassen",
    "addDeliveryHint": "Geben Sie an, was tatsächlich geliefert wurde. Mengen können angepasst werden.",
    "deliveryComplete": "Vollständige Lieferung",
    "deliveryPartial": "Teillieferung",
    "deliveries": "Lieferungen",
    "noLines": "Keine Artikel erfasst",
    "addLine": "Artikel hinzufügen",
    "confirmDelivery": "Lieferung speichern",
    "deleteDeliveryTitle": "Lieferung löschen",
    "deleteDeliveryConfirm": "Diesen Liefereintrag wirklich löschen?",
    "addStock": "Lager hinzufügen",
    "addStockTitle": "Manuellen Lagerbestand hinzufügen",
    "manualStock": "Manueller Bestand",
    "stockDescription": "Beschreibung",
    "stockDescriptionPlaceholder": "z.B. Sack von vorherigem Projekt",
    "stockNotesPlaceholder": "z.B. Von Villa Martin",
    "deleteStockTitle": "Lagereintrag entfernen",
    "deleteStockConfirm": "Diesen Lagereintrag wirklich entfernen?",
    "productName": "Produkt",
    "quantity": "Menge",
    "unit": "Einheit",
    "unitPlaceholder": "z.B. Sack 25 kg",
    "notes": "Notizen",
    "notesPlaceholder": "Optionale Notiz",
    "deliveryNotesPlaceholder": "z.B. Beschädigte oder fehlende Artikel",
    "confirmOrder": "Bestellung bestätigen",
    "draftHint": "Noch keine Bestellung erfasst. Klicken Sie auf 'Als bestellt markieren', sobald die Bestellung aufgegeben wurde.",
    "consumption": "Materialbedarf",
    "orderAlerts": "Bestellhinweise",
    "daysLate": "{{count}} Tag Verzug",
    "daysLate_other": "{{count}} Tage Verzug",
    "order": "Bestellen",
    "orderOnShopify": "Auf masmaya.com bestellen",
    "productList": "Zu bestellende Produkte",
    "sectionOrderWarningTitle": "Bestellung nur für diesen Bereich",
    "sectionOrderWarningBody": "Eine Bestellung nur für diesen Bereich kann teurer sein als für das gesamte Projekt: Das Gesamtprojekt erreicht manchmal Mengenschwellen (300-kg- oder 1000-kg-Säcke), die ein einzelner Bereich nicht erreicht — besonders wenn der Baustellenzugang solche großen Gebinde zulässt. Prüfen Sie vor der Bestellung die Projektgesamtsumme.",
    "sectionOrderWarningConfirm": "Trotzdem bestellen"
  },
  "assignedPeople": {
    "add": "Person hinzufügen",
    "search": "Suchen…",
    "noResults": "Keine Ergebnisse",
    "replace": "Ersetzen",
    "remove": "Entfernen"
  },
  "common": {
    "customer": "Kunde",
    "days": "Tage",
    "error": "Ein Fehler ist aufgetreten",
    "goHome": "Zur Startseite",
    "loading": "Lädt...",
    "login": "Anmelden",
    "cancel": "Abbrechen",
    "create": "Erstellen",
    "save": "Speichern",
    "edit": "Bearbeiten",
    "remove": "Entfernen",
    "archive": "Archivieren",
    "delete": "Löschen",
    "open": "Öffnen",
    "add": "Hinzufügen",
    "close": "Schließen",
    "zoom": "Zoomen",
    "back": "Zurück",
    "rename": "Umbenennen",
    "unsavedChanges": "Nicht gespeicherte Änderungen",
    "discardChangesTitle": "Änderungen verwerfen?",
    "discardChangesConfirm": "Sie haben nicht gespeicherte Änderungen. Möchten Sie diese wirklich verwerfen?",
    "discardChangesAction": "Verwerfen",
    "view": "Anzeigen",
    "search": "Suchen…",
    "tooManyResults": "Zu viele Ergebnisse, verfeinern Sie Ihre Suche",
    "next": "Weiter",
    "confirm": "Bestätigen",
    "selectAll": "Alle auswählen",
    "deselectAll": "Auswahl aufheben",
    "change": "Bearbeiten",
    "notFound": "Nicht gefunden",
    "total": "Gesamt"
  },
  "user": {
    "profile": "Profil",
    "logout": "Abmelden",
    "noEntity": "Keine Entität ausgewählt"
  },
  "products": {
    "title": "Produkte",
    "createButton": "Neues Produkt",
    "createTitle": "Produkt erstellen",
    "editTitle": "Produkt bearbeiten",
    "importButton": "CSV importieren",
    "searchPlaceholder": "Nach Name, Variante oder Kategorie suchen...",
    "allCategories": "Alle Kategorien",
    "excludeSamples": "Muster ausschließen",
    "noData": "Keine Produkte gefunden",
    "grouped": "Gruppiert",
    "table": "Tabelle",
    "columns": {
      "category": "Kategorie",
      "name": "Name",
      "variant": "Variante",
      "color": "Farbe",
      "sizeWeight": "Größe / Gewicht",
      "dimensions": "Abmessungen",
      "price": "Preis (EUR)"
    },
    "form": {
      "category": "Kategorie",
      "categoryRequired": "Kategorie ist erforderlich",
      "name": "Produktname",
      "nameRequired": "Name ist erforderlich",
      "variant": "Variante",
      "variantRequired": "Variante ist erforderlich",
      "color": "Farbe",
      "sizeWeight": "Größe / Gewicht",
      "dimensions": "Abmessungen",
      "price": "Preis (EUR)",
      "priceRequired": "Preis muss 0 oder größer sein",
      "sku": "SKU",
      "imageUrl": "Bild-URL",
      "shopifyVariantId": "Shopify Varianten-ID"
    },
    "delete": {
      "title": "Produkt löschen",
      "confirm": "Möchten Sie \"{{name}}\" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden."
    },
    "import": {
      "title": "Produkte aus CSV importieren",
      "description": "Laden Sie eine tabulatorgetrennte Datei (.csv / .tsv) mit folgenden Spalten hoch:",
      "selectFile": "Datei auswählen",
      "action": "Importieren",
      "success": "Import erfolgreich",
      "imported": "{{count}} Produkte importiert.",
      "close": "Schließen"
    },
    "backToList": "Zurück zu Produkten",
    "shopifySync": {
      "button": "Von Shopify synchronisieren",
      "error": "Shopify-Synchronisierung fehlgeschlagen",
      "successMessage": "{{updated}} Produkte aktualisiert, {{created}} erstellt",
      "successTitle": "Shopify-Synchronisierung abgeschlossen"
    }
  },
  "language": {
    "label": "Sprache",
    "en": "Englisch",
    "fr": "Französisch",
    "de": "Deutsch"
  },
  "pages": {
    "login": {
      "pageTitle": "Anmelden"
    },
    "notFound": {
      "message": "Seite nicht gefunden",
      "title": "Hoppla"
    },
    "milestones": {
      "pageTitle": "Meilensteine"
    },
    "staff": {
      "pageTitle": "Personal"
    },
    "taskGeneration": {
      "pageTitle": "Aufgabengenerierung"
    },
    "quote": {
      "pageTitle": "Angebot"
    },
    "roomCalculation": {
      "pageTitle": "Raumberechnung"
    },
    "company": {
      "pageTitle": "Unternehmen"
    },
    "entityDetail": {
      "pageTitle": "Entitätsdetails"
    },
    "entities": {
      "pageTitle": "Entitäten"
    }
  },
  "projects": {
    "title": "Projekte",
    "createButton": "Neues Projekt",
    "createTitle": "Projekt erstellen",
    "editTitle": "Projekt bearbeiten",
    "searchPlaceholder": "Nach Name suchen...",
    "allStatuses": "Alle Status",
    "noData": "Keine Projekte gefunden",
    "late": "Verspätet",
    "noClient": "Kein Kunde zugewiesen",
    "presentationMode": {
      "enter": "Präsentationsmodus aktivieren (blendet Preise und interne Notizen aus)",
      "exit": "Präsentationsmodus beenden"
    },
    "tracking": {
      "title": "Nachverfolgung"
    },
    "sequenceGenerator": {
      "title": "Aufgabensequenz generieren",
      "description": "Generieren Sie automatisch eine terminierte, abhängigkeitsbewusste Mas Maya Aufgabensequenz für einen Projektabschnitt.",
      "sectionLabel": "Abschnitt",
      "startDateLabel": "Startdatum",
      "generatingPreview": "Vorschau wird generiert…",
      "generatedSequence": "Generierte Sequenz",
      "steps": "Schritte",
      "calendarDays": "Kalendertage",
      "work": "Arbeit",
      "dry": "Trocknung",
      "cure": "Aushärtung",
      "generationFailed": "Generierung fehlgeschlagen",
      "unexpectedError": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
      "confirmAndGenerate": "Bestätigen und generieren",
      "createStepsAndTasks": "Schritte und Aufgaben erstellen",
      "cancel": "Abbrechen",
      "premiumFinish": "Premium-Finish",
      "repair": "Reparatur",
      "highTraffic": "Hohe Belastung",
      "confirmMessage": "Dies erstellt <1>{{stepCount}} Projektschritte</1> und <2>{{taskCount}} Aufgaben</2> im Projekt. Vorhandene Schritte und Aufgaben werden nicht entfernt.",
      "taskCount_one": "{{count}} Aufgabe",
      "taskCount_other": "{{count}} Aufgaben",
      "photoLabel": "{{count}}+ Fotos",
      "stepTypes": {
        "SubstratePreparation": "Untergrundvorbereitung",
        "PrimerApplication": "Primer-Auftrag",
        "BaseLayer": "Grundschicht",
        "MeshInstallation": "Gitter-Installation",
        "FinishingCoat": "Deckschicht",
        "Smoothing": "Glätten",
        "Presealer": "Presealer",
        "Sealer": "Sealer",
        "HeavyDutySealer": "Heavy-Duty Sealer",
        "CuringStep": "Aushärtungszeit",
        "ProtectionPeriod": "Schutzzeit",
        "Handover": "Übergabe"
      }
    },
    "columns": {
      "name": "Name",
      "status": "Status",
      "manager": "Projektleiter",
      "entity": "Entität",
      "startDate": "Start",
      "endDate": "Ende"
    },
    "status": {
      "Draft": "Entwurf",
      "Planned": "Geplant",
      "InProgress": "In Bearbeitung",
      "OnHold": "Pausiert",
      "Completed": "Abgeschlossen",
      "Archived": "Archiviert",
      "AwaitingDelivery": "Wartet auf Lieferung",
      "Blocked": "Blockiert",
      "AwaitingValidation": "Wartet auf Validierung",
      "CorrectionRequired": "Korrektur erforderlich"
    },
    "executionMode": {
      "ExternalOnly": "Projet DIY",
      "MasMayaManaged": "Mas Maya Certified Applicator",
      "MasMayaExecuted": "Mas Maya Executed",
      "ExternalOnlyDescription": "Der Kunde führt die Arbeiten selbst aus",
      "MasMayaExecutedDescription": "Durch Mas Maya Teams ausgeführt",
      "MasMayaManagedDescription": "Zertifizierter Mas Maya Applikator"
    },
    "applicators": {
      "title": "Applikateur-Team",
      "selectLabel": "Applikateur hinzufügen",
      "selectPlaceholder": "Internen Applikateur suchen...",
      "assign": "Zuweisen",
      "empty": "Noch keine Applikateure zugewiesen — verwenden Sie die Auswahl oben, um einen hinzuzufügen.",
      "requiresDates": "Legen Sie geplante Start- und Enddaten am Projekt fest, bevor Sie Applikateure zuweisen.",
      "removeTitle": "Applikateur entfernen",
      "removeConfirm": "{{name}} aus dem Applikateur-Team entfernen?"
    },
    "sections": {
      "general": "Allgemeine Informationen",
      "contact": "Hauptkontakt",
      "documents": "Dokumente"
    },
    "form": {
      "name": "Name",
      "nameRequired": "Name ist erforderlich",
      "entity": "Entität",
      "entityRequired": "Entität ist erforderlich",
      "manager": "Projektleiter",
      "managerRequired": "Projektleiter ist erforderlich",
      "managerPlaceholder": "Benutzer suchen...",
      "managerNoResults": "Keine Benutzer gefunden",
      "status": "Status",
      "date": "Datum",
      "startTime": "Startzeit",
      "endTime": "Endzeit",
      "startDate": "Startdatum",
      "endDate": "Enddatum",
      "endDateNoSections": "Noch keine Abschnitte",
      "endDateCalculating": "Wird berechnet...",
      "surface": "Gesamtfläche (m²)",
      "description": "Beschreibung",
      "notes": "Notizen",
      "primaryContact": "Hauptkontakt",
      "primaryContactPlaceholder": "Kontakt suchen...",
      "primaryContactNoResults": "Keine Kontakte gefunden",
      "primaryContactClear": "— Kontakt entfernen",
      "executionMode": "Ausführungsmodus",
      "addressLine1": "Adresse",
      "city": "Stadt",
      "country": "Land",
      "countryRequired": "Das Land ist erforderlich",
      "namePlaceholder": "Residenz, Villa Müller...",
      "projectTypeSubtitle": "Was für eine Baustelle ist es?",
      "projectTypeTitle": "Projekttyp",
      "sectionSourceSubtitle": "Sie können später jederzeit weitere Abschnitte hinzufügen oder importieren.",
      "sectionSourceTitle": "Wie möchten Sie die Abschnitte erstellen?"
    },
    "delete": {
      "title": "Projekt löschen",
      "confirm": "Möchten Sie \"{{name}}\" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "action": "Löschen"
    },
    "documents": {
      "dropzoneTitle": "Dateien hier ablegen oder zum Hochladen klicken",
      "dropzoneHint": "Jeder Dateityp akzeptiert",
      "preview": "Vorschau",
      "previewUnavailable": "Vorschau für diesen Dateityp nicht verfügbar",
      "download": "Herunterladen",
      "rename": "Umbenennen",
      "removeTitle": "Dokument entfernen",
      "removeConfirm": "\"{{name}}\" aus diesem Projekt entfernen?"
    },
    "resources": {
      "title": "Ressourcen",
      "professionalContacts": "Geschäftskontakte",
      "addTitle": "Ressource hinzufügen",
      "email": "E-Mail",
      "emailPlaceholder": "name@beispiel.de",
      "displayName": "Vor- und Nachname",
      "displayNamePlaceholder": "Max Mustermann",
      "role": "Rolle",
      "removeTitle": "Ressource entfernen",
      "removeConfirm": "{{name}} aus diesem Projekt entfernen?",
      "columns": {
        "name": "Name",
        "email": "E-Mail",
        "role": "Rolle",
        "linked": "Konto"
      },
      "empty": "Noch keine Teammitglieder zugewiesen — fügen Sie unten eines hinzu.",
      "linked": "Verknüpft",
      "pending": "Ausstehend",
      "roles": {
        "PM": "Projektleiter",
        "Worker": "Arbeiter",
        "QualityManager": "Qualitätsverantwortlicher"
      },
      "noAvailable": "Keine Person zum Zuweisen verfügbar",
      "certifiedGroup": "Zertifizierte Anwender",
      "selectCertifiedCompanies": "Unternehmen mit zertifiziertem Anwender"
    },
    "projectSections": {
      "title": "Abschnitte",
      "createTitle": "Abschnitt hinzufügen",
      "editTitle": "Abschnitt bearbeiten",
      "add": "Abschnitt hinzufügen",
      "empty": "Keine Abschnitte vorhanden",
      "wet": "Nass",
      "submerged": "Eingetaucht",
      "protected": "Geschützt",
      "exterior": "Außen",
      "renameFloor": "Stockwerk umbenennen",
      "deleteTitle": "Abschnitt löschen",
      "deleteConfirm": "Abschnitt \"{{label}}\" löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "columns": {
        "label": "Bezeichnung",
        "color": "Farbe",
        "type": "Typ",
        "surface": "Oberfläche",
        "finish": "Finish",
        "surfaceM2": "Fläche",
        "flags": "Optionen",
        "workers": "Arbeiter"
      },
      "stepProgress": "Schritt {{current}} von {{total}}"
    },
    "sectionForm": {
      "label": "Bezeichnung",
      "color": "Farbe",
      "colorPlaceholder": "Farbe suchen...",
      "colorClear": "— Farbe entfernen",
      "colorNoResults": "Keine Farben gefunden",
      "type": "Typ",
      "roomSubtype": "Untertyp",
      "substrate": "Untergrund",
      "finish": "Finish",
      "surfaceM2": "Fläche (m²)",
      "exposure": "Exposition",
      "condition": "Untergrundszustand",
      "traffic": "Verkehr",
      "insideCornerLinearM": "Innenecken (ml)",
      "insideCornerHint": "Mesh an Innenecken nicht falten",
      "outsideCornerLinearM": "Außenecken (ml)",
      "outsideCornerHint": "Mesh 10 cm beidseitig wickeln",
      "isCurved": "Gewölbte Fläche",
      "isCurvedHint": "Bogen, Säule, Gewölbe (+15 % Verschnitt)",
      "isRepair": "Reparatur / kleiner Flicken",
      "isRepairHint": "Mindestpauschalmenge",
      "roomWidthM": "Breite (m)",
      "roomLengthM": "Länge (m)",
      "roomHeightM": "Höhe (m)",
      "includedSurfaces": "Eingeschlossene Flächen",
      "coatFloor": "Boden",
      "coatWalls": "Wände",
      "coatCeiling": "Decke",
      "repairForfaitBadge": "Pauschale",
      "workers": "Zugewiesene Arbeiter",
      "workersPlaceholder": "Arbeiter auswählen...",
      "quantityPreview": "Mengenvorschau",
      "layerCount": "Schicht(en)",
      "meshForcedNotice": "Mesh für diesen Untergrundtyp obligatorisch — nicht deaktivierbar",
      "waterproofMembrane": "Abdichtungsmembran",
      "waterproofConfirmed": "Vorhanden und bestätigt",
      "waterproofAbsent": "Fehlend oder nicht geprüft",
      "waterproofUnknown": "Auswählen...",
      "waterproofExplanation": "Mas Maya ist ein wasserresistenter Belag, kein Abdichtungssystem. Eine Abdichtungsmembran (z.B. Schlüter-KERDI, Aqua-Panel) muss vor der Anwendung in Nassbereichen installiert werden.",
      "waterproofBlockingWarning": "Speichern nicht möglich: Eine bestätigte Abdichtungsmembran ist für Nassbereiche erforderlich.",
      "waterproofToPose": "Membran zu verlegen",
      "waterproofWillBeAdded": "Keine Membran vorhanden — die Membran sowie Ecken-/Rohrdurchführungsverstärkungen werden dem Materialkorb hinzugefügt.",
      "insideCornerCount": "Anzahl Innenecken",
      "insideCornerCountHint": "Anzahl der zu montierenden Innenecken-Verstärkungen (z. B. 4 bei einem rechteckigen Pool)",
      "outsideCornerCount": "Anzahl Außenecken",
      "outsideCornerCountHint": "Anzahl der zu montierenden Außenecken-Verstärkungen",
      "pipePenetrationCount": "Anzahl Rohrdurchführungen",
      "pipePenetrationCountHint": "Anzahl der zu montierenden Rohrdurchführungsverstärkungen",
      "system": {
        "standard1Layer": "Trocken — 1 Schicht",
        "premium2Layers": "Trocken — 2 Schichten",
        "mesh2Layers": "Mesh — 2 Schichten",
        "pool": "Pool — Kritisches System",
        "exterior": "Außen — Fassade",
        "exteriorFloor": "Außen — Boden / Terrasse"
      },
      "riskLevel": {
        "low": "Geringes Risiko",
        "medium": "Mittleres Risiko",
        "high": "Hohes Risiko",
        "very-high": "Sehr hohes Risiko",
        "critical": "Kritisches Risiko"
      },
      "warnings": {
        "deterioratedSupport": "Beschädigter Untergrund — Prep erforderlich",
        "tilesAlwaysMesh": "Vorhandene Fliesen — Prep + Mesh erforderlich (Fugenbewegung)",
        "floorMesh": "Boden — Mesh + Presealer + Sealer erforderlich",
        "stepsMeshNosing": "Treppen — Mesh über Stufennasen, Presealer + Sealer inklusive",
        "brickBlockMesh": "Gefugter Untergrund — Mesh erforderlich",
        "plasterboardMovement": "Gipsplatte / Trennwand — Bewegungsrisiko, Mesh erforderlich",
        "wetZone": "Badezimmer (kein direkter Wasserkontakt) — Mesh + Schutz erforderlich",
        "directWaterZone": "Direkter Wasserkontakt — Pool Primer automatisch ausgewählt",
        "waterproofMembraneRequired": "Abdichtungsmembran erforderlich — vor Anwendung bestätigen",
        "masMayaWaterResistant": "Mas Maya ist wasserresistent, aber nicht wasserdicht — vorherige Membran obligatorisch",
        "submergedZone": "Tauchzone — Pool Primer + Mesh",
        "exteriorExposure": "Außenbereich — UV-Schutz erforderlich",
        "sealingRequired": "Schutz angefordert — Presealer + Sealer inklusive",
        "heavyDutyRecommended": "Heavy-Duty Sealer für diesen Oberflächentyp empfohlen",
        "poolWaterproofMembrane": "Pool — Abdichtungsmembran vor Pool Primer erforderlich",
        "poolWaterline": "Heavy-Duty Sealer an der Wasserlinie (±20 cm) erforderlich",
        "poolAftercare3Weeks": "Idealerweise 3 Wochen warten vor dem Befüllen",
        "exteriorFacadeMesh": "Außenfassade — Mesh + Presealer + Sealer erforderlich",
        "drainageSlopeWarning": "Gefälle (min. 1,5 %) und Entwässerung vor Anwendung prüfen",
        "exteriorHeavyDuty": "Außenboden — Heavy-Duty Sealer erforderlich (UV + Verkehrsbeständigkeit)",
        "curingTime72h": "Endaushärtezeit: mindestens 72h nach letzter Sealer-Schicht",
        "furnitureMesh": "Holz / MDF — Bewegungsrisiko, Mesh erforderlich",
        "insideCornerNoFold": "Innenecken — Mesh nicht falten, Streifen schneiden und überlappen",
        "outsideCornerMesh": "Außenecken — Mesh 10 cm beidseitig gewickelt (+0,20 m²/ml)",
        "curvedSurfaceFactor": "Gewölbte Fläche — +15 % Beschichtungs- und Mesh-Verschnitt",
        "repairForfait": "Reparatur — Mindestpauschalmenge angewendet"
      },
      "types": {
        "Wall": "Wand",
        "Pool": "Pool",
        "Facade": "Fassade",
        "Steps": "Treppen",
        "Furniture": "Möbel / Einbauschrank",
        "Room": "Raum"
      },
      "typeDescriptions": {
        "Room": "Raum mit Boden, Wänden und Decke",
        "Wall": "Innenwandfläche",
        "Pool": "Schwimmbad oder untergetauchtes Becken",
        "Facade": "Außenfassade",
        "Steps": "Treppen oder Treppenstufen-Vorderkanten",
        "Furniture": "Möbel, Schrank oder Objekt"
      },
      "roomSubtypes": {
        "Bathroom": "Badezimmer",
        "Default": "Standard"
      },
      "substrates": {
        "Tiles": "Fliesen",
        "Concrete": "Beton",
        "Wood": "Holz",
        "Brick": "Ziegel",
        "Block": "Betonstein",
        "Plasterboard": "Gipsplatte / Trennwand"
      },
      "finishes": {
        "Standard": "Standard",
        "Premium": "Premium"
      },
      "protectionLevels": {
        "None": "Keine",
        "Presealer": "Nur Presealer",
        "PresealerSealer": "Presealer + Acryl-Versiegelung",
        "PresealerHeavyDutySealer": "Presealer + Heavy-Duty-Versiegelung"
      },
      "exposures": {
        "None": "Keine",
        "Wet": "Nassraum (Bad — kein direkter Wasserkontakt)",
        "DirectWater": "Direkter Wasserkontakt (Dusche / Waschbecken / Wanne)",
        "Submerged": "Eingetaucht (Pool / Brunnen)",
        "Outside": "Außenbereich",
        "WaterProtected": "Wasserschutz (Kundenwunsch)",
        "SolvantProtected": "Lösungsmittelschutz Heavy-Duty"
      },
      "conditions": {
        "New": "Neu",
        "Good": "Guter Zustand",
        "Normal": "Normal",
        "Deteriorated": "Beschädigt (Prep erforderlich)"
      },
      "trafficLevels": {
        "None": "Kein",
        "Low": "Niedrig",
        "Medium": "Mittel",
        "High": "Hoch"
      },
      "typeChangeReset": "Einige Felder wurden zurückgesetzt, da sie nicht mit diesem Abschnittstyp kompatibel sind.",
      "underfloorHeating": "Fußbodenheizung",
      "underfloorHeatingPlaceholder": "Nicht angegeben",
      "underfloorHeatingYes": "Ja — Fußbodenheizung vorhanden",
      "underfloorHeatingNo": "Nein — keine Fußbodenheizung",
      "underfloorHeatingType": "Heizungstyp",
      "underfloorHeatingUnknown": "Unbekannter Typ",
      "underfloorHeatingWater": "Warmwasser",
      "underfloorHeatingElectric": "Elektrisch",
      "isExteriorRoom": "Exterior",
      "isExteriorRoomHint": "Der Raum ist der Außenumgebung ausgesetzt",
      "isFurnishedRoom": "Möblierter Raum",
      "isFurnishedRoomHint": "Contains furniture to protect",
      "isOccupiedSite": "Belegte Baustelle",
      "isOccupiedSiteHint": "Die Baustelle ist während der Arbeiten in Nutzung",
      "roomBreakdown": {
        "ceilingM2": "Berechnete Decke",
        "floorM2": "Berechneter Boden",
        "heightCoefficient": "Höhenkoeffizient",
        "heightM": "Höhe",
        "noRoomParams": "Berechnungskonfiguration nicht verfügbar",
        "placeholderHeightWarning": "Höhe nicht angegeben — vorübergehend 2,5 m für Berechnung verwendet",
        "surfaceM2": "Raumfläche",
        "totalM2": "Berechnet gesamt:",
        "wallsM2": "Berechnete Wände"
      },
      "roomHeightPlaceholder": "Höhe nicht angegeben — standardmäßig 2,5 m für Berechnungen verwendet",
      "selectFinish": "Oberfläche auswählen...",
      "selectSubstrate": "Untergrund auswählen...",
      "surface": {
        "ceiling": "Decke",
        "floor": "Boden",
        "walls": "Wände"
      },
      "surfaceConfig": "Konfiguration nach Fläche",
      "steps": {
        "identity": "Identität",
        "type": "Typ",
        "parameters": "Parameter",
        "validation": "Validierung"
      },
      "identityTitle": "Abschnittsidentität",
      "identitySubtitle": "Benennen Sie diesen Abschnitt und verknüpfen Sie eine Mas Maya Farbe.",
      "typeTitle": "Abschnittstyp",
      "typeSubtitle": "Welche Art von Oberfläche möchten Sie konfigurieren?",
      "roomConfigTitle": "Raumkonfiguration",
      "roomConfigSubtitle": "Geben Sie die Abmessungen und zu behandelnden Oberflächen ein.",
      "standardConfigSubtitle": "Geben Sie die technischen Merkmale dieser Oberfläche ein.",
      "summaryTitle": "Zusammenfassung",
      "summarySubtitle": "Überprüfen Sie die Informationen vor der Erstellung des Abschnitts.",
      "colorModes": {
        "SingleColor": "Einzelne Farbe",
        "PerSurface": "Farbe pro Fläche"
      },
      "colorPerSurfaceHint": "Wählen Sie im Schritt Parameter eine Farbe für jede Oberfläche.",
      "subtypeLabel": "Raumuntertyp",
      "subtypes": {
        "Default": {
          "label": "Standard",
          "description": "Raum ohne spezifische Konfiguration"
        },
        "Bathroom": {
          "label": "Badezimmer",
          "description": "Premium-Finish + DirectWater-Exposition erzwungen"
        },
        "Kitchen": {
          "label": "Küche",
          "description": "Demnächst verfügbar"
        },
        "Bedroom": {
          "label": "Schlafzimmer",
          "description": "Demnächst verfügbar"
        },
        "SpaHammam": {
          "label": "Spa / Hammam",
          "description": "Demnächst verfügbar"
        }
      },
      "comingSoon": "Demnächst verfügbar",
      "floorColorLabel": "Bodenfarbe",
      "wallsColorLabel": "Wandfarbe",
      "ceilingColorLabel": "Deckenfarbe",
      "createSection": "Abschnitt erstellen",
      "selectColorPlaceholder": "Farbe auswählen…",
      "labelPlaceholderRoom": "z. B. Hauptwohnzimmer, Badezimmer oben…",
      "surfacesToTreat": "Zu behandelnde Flächen",
      "siteCharacteristics": "Baustellenmerkmale",
      "createdTitle": "Abschnitt erstellt"
    },
    "consumption": {
      "title": "Produktverbrauch",
      "projectTotal": "Projektgesamt",
      "perSection": "Pro Abschnitt"
    },
    "materials": {
      "title": "Materialbestellung",
      "projectTotal": "Bestellliste",
      "perSection": "Pro Abschnitt",
      "product": "Produkt",
      "qty": "Mge",
      "cost": "Kosten",
      "noProducts": "Keine Produkte anzuzeigen",
      "noSections": "Noch keine Abschnitte — fügen Sie im Tab Abschnitte einen Abschnitt hinzu, um den Materialbedarf zu sehen.",
      "productNotFound": "Kein passendes Produkt im Katalog gefunden",
      "orderOnShopify": "Auf masmaya.com bestellen",
      "largeVolumeActive": "Großvolumenzugang aktiv",
      "largeVolumeActiveDesc": "Säcke mit 300 kg und 1000 kg sind enthalten. Falls diese Baustelle keine Palettenlieferungen annehmen kann, deaktivieren Sie den Großvolumenzugang in den Projekteinstellungen.",
      "limitedAccess": "Eingeschränkter Zugang — es werden nur kleine Gebinde angeboten.",
      "line": {
        "prep": "Mas Maya Prep",
        "poolPrimer": "Mas Maya Pool Primer",
        "primer": "Mas Maya Primer",
        "coating1Layer": "Mas Maya Coating (1 Schicht)",
        "coating2Layer": "Mas Maya Coating (2 Schichten)",
        "mixingWater": "Anmachwasser",
        "mesh": "Mas Maya Mesh",
        "presealer": "Mas Maya Presealer",
        "sealer": "Mas Maya Sealer",
        "heavyDutySealer": "Mas Maya Heavy-Duty Sealer",
        "waterproofMembrane": "Waterproof Membrane",
        "waterproofCornerReinforcement": "Waterproof Corner Reinforcement",
        "waterproofPipeReinforcement": "Waterproof Pipe Reinforcement",
        "pigment": "Pigment {{name}}"
      }
    },
    "quote": {
      "title": "Geschäftsangebot",
      "breakdown": "Detaillierte Aufschlüsselung",
      "copyText": "Als Text kopieren",
      "copied": "Kopiert!",
      "materials": "Materialien",
      "labour": "Arbeitszeit",
      "recipientEmail": "E-Mail des Empfängers",
      "downloadPdf": "Als PDF herunterladen",
      "sendByEmail": "Per E-Mail senden",
      "provisionalDimensionsWarning": "Ein oder mehrere Abschnitte verwenden eine vorläufige (unbestätigte) Raumhöhe. Die angezeigten Mengen und Kosten sind indikativ — der E-Mail-Versand und die Erstellung eines Holded-Angebots sind deaktiviert, bis die tatsächliche Höhe im Abschnitt eingetragen wurde.",
      "provisionalBadge": "Vorläufig",
      "pdfError": "Fehler beim Erstellen des PDFs",
      "emailSuccess": "Geschäftsangebot per E-Mail an {{email}} gesendet",
      "emailError": "Fehler beim Versenden des Geschäftsangebots per E-Mail",
      "showPreview": "Geschäftsangebot ansehen",
      "client": "Kunde",
      "project": "Projekt",
      "totalSurface": "Gesamtfläche: {{surface}} m²",
      "sectionsProgress": "Abschnitte: {{done}} / {{total}} abgeschlossen",
      "estimatedTime": "Geschätzte Zeit: {{hours}} Std.",
      "totalEstimated": "Geschätzte Gesamtsumme",
      "disclaimer": "Dieses Geschäftsangebot ist unverbindlich und basiert auf den im Projekt hinterlegten Angaben; es kann nach einer technischen Vor-Ort-Besichtigung angepasst werden.",
      "sectionsHeading": "Details je Abschnitt",
      "whyTitle": "Warum Mas Maya?",
      "whyIntro": "Als Spezialist für Abdichtung und dekorative Beschichtungen für Pools, Nassräume und Fassaden entwickelt Mas Maya langlebige, elegante und pflegeleichte Systeme.",
      "whyPoint1Title": "Netzwerk zertifizierter Applikateure",
      "whyPoint1Text": "Eine Ausführung, garantiert durch geschulte, Mas Maya-zertifizierte Fachkräfte in ganz Frankreich.",
      "whyPoint2Title": "Premium-Oberflächen",
      "whyPoint2Text": "Gepflegte Ergebnisse und eine breite Farbpalette, gemacht, um lange zu halten.",
      "whyPoint3Title": "Begleitung nach Maß",
      "whyPoint3Text": "DIY, zertifizierter Applikateur oder schlüsselfertige Ausführung durch unsere eigenen Teams: Sie wählen Ihr Niveau an Begleitung.",
      "addSectionToCart": "Zum Mas-Maya-Warenkorb hinzufügen",
      "addProjectToCart": "Gesamtes Projekt zum Mas-Maya-Warenkorb hinzufügen",
      "timeline": "Anwendungszeitplan",
      "totals": "Projektsummen",
      "rawHours": "Rohstunden",
      "adjustedHours": "Angepasste Stunden",
      "totalRawHours": "Rohstunden gesamt",
      "totalHours": "Stunden gesamt (angepasst)",
      "noSections": "Keine Abschnitte mit Angebotsdaten.",
      "textHeader": "ANGEBOT — {{name}}",
      "textSection": "Abschnitt",
      "complexityLevel": {
        "low": "Geringe Komplexität",
        "normal": "Standard",
        "medium": "Mittlere Komplexität",
        "high": "Hohe Komplexität"
      },
      "tasks": {
        "prep": "Vorbereitung",
        "primer": "Primer",
        "coating": "Beschichtung",
        "smoothing": "Glätten / Polieren",
        "presealer": "Presealer",
        "sealer": "Sealer",
        "heavyDutySealer": "Heavy-Duty Sealer"
      },
      "timelineSteps": {
        "afterPrep": "Nach Vorbereitung",
        "afterPrimer": "Nach Primer",
        "betweenLayers": "Zwischen Schichten",
        "afterSmoothing": "Nach Glätten",
        "afterPresealer": "Nach Presealer",
        "afterSealer": "Nach Sealer",
        "afterHeavyDutySealer": "Nach Heavy-Duty Sealer",
        "poolFill": "Vor dem Befüllen"
      }
    },
    "workflow": {
      "title": "Arbeitsstatus",
      "notes": "Notizen",
      "notesPlaceholder": "Notiz hinzufügen...",
      "photos": "Fotos",
      "addPhotos": "Fotos hinzufügen",
      "photoRequired": "Mindestens ein Foto ist erforderlich",
      "history": "Verlauf",
      "approved": "Qualität genehmigt",
      "status": {
        "InProgress": "In Arbeit",
        "WorkerDone": "Arbeit abgeschlossen",
        "QualityApproved": "Genehmigt"
      },
      "changeType": {
        "WorkerDone": "Arbeit abgeschlossen",
        "QualityApproved": "Genehmigt",
        "QualitySkipped": "Prüfung übersprungen",
        "QualityRejected": "Abgelehnt"
      },
      "workerDone": {
        "title": "Als abgeschlossen markieren",
        "description": "Laden Sie mindestens ein Foto hoch, um die Fertigstellung zu bestätigen.",
        "action": "Als abgeschlossen markieren",
        "submit": "Fertigstellung bestätigen"
      },
      "quality": {
        "title": "Qualitätskontrolle",
        "description": "Überprüfen Sie den Abschnitt und genehmigen oder lehnen Sie die Arbeit ab.",
        "action": "Qualitätskontrolle",
        "approve": "Genehmigen",
        "reject": "Ablehnen",
        "skipCheck": "Qualitätskontrolle überspringen (keine Inspektion erforderlich)"
      }
    },
    "cards": {
      "sections": "{{done}} / {{total}} Abschnitte genehmigt",
      "totalProject": "Projekttotal",
      "labour": "Arbeit",
      "materials": "Materialien",
      "incompleteCalc": "Berechnung unvollständig",
      "materialsShort": "Mat.",
      "labourShort": "Arb."
    },
    "sectionAttrs": {
      "characteristics": "Eigenschaften",
      "conditions": "Nutzungsbedingungen",
      "dimensions": "Fläche und Geometrie",
      "roomDimensions": "Raumabmessungen",
      "conditionsStandard": "Standardbedingungen",
      "color": "Farbe",
      "noColor": "Keine Farbe definiert",
      "surfaceComputed": "Berechnete Fläche",
      "surfaceComputedHint": "wird nach dem Speichern aktualisiert",
      "surfaceUsed": "Verwendete Fläche",
      "surfaceOverridden": "Überschriebene Fläche",
      "surfaceOverride": "Manuelle Überschreibung",
      "surfaceOverrideHint": "Leer lassen, um die berechnete Fläche zu verwenden",
      "surfaceOverridePlaceholder": "Fläche in m²",
      "noDimensions": "Keine Abmessungen angegeben",
      "roomWidth": "Breite",
      "roomLength": "Länge",
      "roomHeight": "Höhe",
      "coatWalls": "Wände beschichten",
      "coatCeiling": "Decke beschichten",
      "coatFloor": "Boden beschichten",
      "parameters": "Parameter",
      "siteOccupied": "Bewohntes Objekt",
      "furnishedRoom": "Möbliertes Zimmer",
      "complexityLabel": "Komplexität",
      "furnishedMarkupLabel": "möbliert",
      "occupiedMarkupLabel": "bewohnt",
      "standardFinishDiscountLabel": "Standardfinish",
      "editColorsHint": "Farben unten unter Parameter bearbeiten",
      "coatingSurfaceSuffix": "m² zu beschichten"
    },
    "bulkColor": {
      "title": "Farbe auf alle Abschnitte anwenden",
      "hint": "Die ausgewählte Farbe wird auf alle {{count}} Abschnitt(e) des Projekts angewendet.",
      "removeAll": "Farbe von allen Abschnitten entfernen",
      "confirmTitle": "Anwendung bestätigen",
      "confirmApply": "Farbe '{{color}}' auf {{count}} Abschnitt(e) anwenden?",
      "confirmRemove": "Farbe von allen {{count}} Abschnitt(en) entfernen?",
      "appliedMessage": "Farbe auf die ausgewählten Abschnitte angewendet.",
      "removedMessage": "Farbe von den ausgewählten Abschnitten entfernt."
    },
    "bulkFinishProtection": {
      "title": "Finish und Schutz (gesamtes Projekt)",
      "hint": "Diese Einstellungen gelten immer für das gesamte Projekt — Materialverbrauch und Arbeitskosten hängen davon ab.",
      "finishLabel": "Finish",
      "protectionLabel": "Schutz",
      "apply": "Auf das gesamte Projekt anwenden",
      "confirmTitle": "Anwendung bestätigen",
      "confirmApplyFinish": "Finish „{{finish}}“ auf {{count}} Abschnitt(e).",
      "confirmApplyProtection": "Schutz „{{level}}“ auf {{count}} Abschnitt(e).",
      "appliedMessage": "Finish und Schutz auf das gesamte Projekt angewendet."
    },
    "bulkFinish": {
      "title": "Ein Finish auf das gesamte Projekt anwenden",
      "hint": "Dies ändert das Finish für alle Abschnitte des Projekts — der Materialverbrauch unterscheidet sich je nach Finish.",
      "lockedSectionsHint": "{{count}} Abschnitt(e) mit gesperrtem Finish (z. B. Treppen, immer Premium) sind nicht betroffen.",
      "confirmCheckboxLabel": "Mir ist bewusst, dass dies für das gesamte Projekt gilt",
      "apply": "Auf das gesamte Projekt anwenden",
      "confirmTitle": "Anwendung bestätigen",
      "confirmApply": "Das Finish „{{finish}}“ auf alle {{count}} Abschnitte des Projekts anwenden?",
      "appliedMessage": "Finish auf das gesamte Projekt angewendet."
    },
    "bulkProtection": {
      "title": "Eine Schutzstufe auf das gesamte Projekt anwenden",
      "hint": "Dies ändert die Schutzstufe (Presealer / Versiegelung) für alle geeigneten Abschnitte des Projekts — sie wirkt sich auf Materialkosten und Arbeitskosten aus.",
      "lockedSectionsHint": "{{count}} Abschnitt(e) (Pools oder Bereiche mit direktem/untergetauchtem Wasserkontakt) behalten immer ihren erforderlichen Schutz und sind nicht betroffen. Der Boden von Räumen behält ebenfalls immer seinen automatischen Schutz.",
      "confirmCheckboxLabel": "Mir ist bewusst, dass dies für das gesamte Projekt gilt",
      "apply": "Auf das gesamte Projekt anwenden",
      "confirmTitle": "Anwendung bestätigen",
      "confirmApply": "Die Schutzstufe „{{level}}“ auf alle {{count}} Abschnitte des Projekts anwenden?",
      "appliedMessage": "Schutzstufe auf das gesamte Projekt angewendet."
    },
    "bulkType": {
      "title": "Typ auf alle Abschnitte anwenden",
      "hint": "Der ausgewählte Typ wird auf alle {{count}} Abschnitt(e) dieser Etage angewendet.",
      "confirmTitle": "Anwendung bestätigen",
      "confirmApply": "Typ '{{type}}' auf {{count}} Abschnitt(e) anwenden?",
      "coatingStep": "Zu beschichtende Flächen",
      "descriptions": {
        "Room": "Raum mit Boden, Wänden und Decke",
        "Wall": "Innenwandfläche",
        "Pool": "Pool oder eingetauchtes Becken",
        "Facade": "Außenfassade",
        "Steps": "Treppen oder Stufenkanten",
        "Furniture": "Möbel, Schrank oder Objekt"
      }
    },
    "bulkExclude": {
      "title": "Abschnitte aus der Berechnung ausschließen",
      "hint": "Markierte Abschnitte werden nicht in der Material- und Arbeitsberechnung berücksichtigt.",
      "apply": "Anwenden",
      "selectAll": "Alle auswählen",
      "selectNone": "Alle abwählen",
      "banner": "{{count}} Abschnitt(e) aus der Berechnung ausgeschlossen"
    },
    "extractPlan": {
      "title": "Aus Plan extrahieren",
      "hint": "Laden Sie einen Architekturplan hoch, um Räume und ihre Abmessungen automatisch zu extrahieren.",
      "dropZone": "Klicken, um einen Plan auszuwählen (JPG, PNG, PDF...)",
      "extract": "Plan analysieren",
      "noPlans": "Noch keine Pläne hochgeladen. Fügen Sie oben Bilder oder ein PDF hinzu.",
      "uploading": "Wird hochgeladen...",
      "partialError": "{{count}} Seite(n) konnten nicht analysiert werden.",
      "noRoomsFound": "Keine Räume erkannt. Versuchen Sie es mit einem klareren Bild.",
      "converting": "PDF wird konvertiert...",
      "extracting": "Analyse läuft...",
      "error": "Analyse fehlgeschlagen. Prüfen Sie, ob das Bild lesbar ist, und versuchen Sie es erneut.",
      "selectHint": "{{count}} Räume erkannt. Wählen Sie die Räume aus, die zu Abschnitten werden sollen.",
      "confidence": "Konfidenzwert",
      "heightHint": "Im Plan sichtbare oder manuell einzugebende Höhe",
      "applyHeightToAll": "Höhe für alle Räume",
      "createSections": "{{count}} Abschnitt(e) erstellen",
      "creating": "Abschnitte werden erstellt...",
      "generatingTasks": "Nachverfolgungsaufgaben werden generiert...",
      "done": "{{count}} Abschnitt(e) erfolgreich erstellt!",
      "tasksGenerated": "{{count}} Nachverfolgungsaufgabe(n) generiert.",
      "surfaceType": "Welchen Oberflächentyp möchten Sie konfigurieren?"
    },
    "tasks": {
      "form": {
        "title": "Titel",
        "titlePlaceholder": "Aufgabentitel",
        "category": "Kategorie",
        "priority": "Priorität",
        "plannedStart": "Geplantes Startdatum",
        "plannedEnd": "Geplantes Enddatum",
        "datePlaceholder": "Datum auswählen",
        "tabDescription": "Beschreibung",
        "tabTechnical": "Technische Notiz",
        "tabInternal": "Interne Notiz",
        "tabClient": "Kundennotiz",
        "descriptionPlaceholder": "Aufgabenbeschreibung...",
        "technicalPlaceholder": "Technische Notizen...",
        "internalPlaceholder": "Interne Notizen (nicht für den Kunden sichtbar)...",
        "clientPlaceholder": "Kundenanweisungen...",
        "validationRequired": "Validierung erforderlich",
        "weatherSensitive": "Wetterabhängig",
        "clientVisible": "Kundensichtbar",
        "internalOnly": "Nur intern",
        "mandatoryPhoto": "Pflichtfotos",
        "minPhotos": "Min. Fotos",
        "create": "Aufgabe erstellen",
        "save": "Speichern",
        "cancel": "Abbrechen",
        "generatedWarning": "Diese Aufgabe wurde automatisch generiert. Das Bearbeiten dieses Formulars markiert die Aufgabe als manuell geändert.",
        "rejectionTitle": "Ablehnungsbetreff",
        "rejectionTitlePlaceholder": "z.B. Nicht konforme Textur",
        "rejectionReason": "Detaillierter Grund",
        "rejectionReasonPlaceholder": "z.B. Die linke Zone weist einen zu sichtbaren Körnungsunterschied auf...",
        "confirmRejection": "Ablehnung bestätigen",
        "validationNotes": "Validierungsnotizen (optional)",
        "validationNotesPlaceholder": "Notizen für die Akte...",
        "blockingType": "Blockierungstyp",
        "blockingTypeInternal": "Intern (Materialien, Planung, Team...)",
        "blockingTypeExternal": "Extern (andere Gewerke, Kunde, Wetter...)",
        "blockingReason": "Blockierungsgrund",
        "blockingReasonHint": "Erklären Sie, was passieren muss, damit diese Aufgabe entsperrt wird – der Leser sollte genau wissen, was zu tun ist."
      },
      "source": {
        "Generated": "Generiert",
        "Modified": "Geändert",
        "Manual": "Manuell"
      },
      "actions": {
        "title": "Aktionen",
        "start": "Aufgabe starten",
        "requestReview": "Validierung anfordern",
        "resubmit": "Erneut einreichen",
        "validate": "Aufgabe validieren",
        "reject": "Aufgabe ablehnen",
        "unblock": "Aufgabe entsperren",
        "block": "Aufgabe blockieren",
        "addPhotos": "Fotos hinzufügen",
        "edit": "Aufgabe bearbeiten"
      },
      "status": {
        "Todo": "Ausstehend",
        "Active": "In Bearbeitung",
        "ReviewRequested": "In Prüfung",
        "Completed": "Validiert",
        "CorrectionRequired": "Korrektur erforderlich",
        "Blocked": "Blockiert",
        "todoMessage": "Diese Aufgabe ist noch nicht aktiv. Sie startet automatisch nach der Validierung der vorherigen Aufgabe.",
        "awaitingValidation": "Warte auf Validierung durch den Verantwortlichen.",
        "blockedLabel": "Blockiert",
        "blockedWhoInternal": "{{name}} muss handeln, um diese Aufgabe zu entsperren",
        "blockedWhoInternalFallback": "Ihr Team",
        "blockedWhoExternal": "Wartet auf eine externe Aktion (Kunde, Lieferant, anderes Gewerk)",
        "completedLabel": "Aufgabe validiert",
        "correctionRequired": "Aufgabe abgelehnt",
        "instructions": "Anweisungen: {{instructions}}",
        "submittedPhotos": "Eingereichte Fotos",
        "requestReviewTitle": "Fügen Sie mindestens {{count}} Foto(s) hinzu, bevor Sie die Validierung anfordern",
        "resubmitTitle": "Fügen Sie mindestens {{count}} Foto(s) hinzu, bevor Sie erneut einreichen"
      },
      "photos": {
        "title": "Fotos",
        "required": "· {{current}}/{{required}} erforderlich",
        "added": "Foto hinzugefügt",
        "uploadFailed": "Foto-Upload fehlgeschlagen",
        "uploadFailedMessage": "Die Datei kann nicht gesendet werden. Überprüfen Sie das Format oder versuchen Sie es erneut."
      },
      "notifications": {
        "validated": "Aufgabe validiert",
        "nextTaskStarted": "Die nächste Aufgabe ist automatisch gestartet.",
        "lastTaskValidated": "Letzte Aufgabe validiert.",
        "validationError": "Fehler",
        "validationErrorMessage": "Die Aufgabe kann nicht validiert werden.",
        "rejected": "Aufgabe abgelehnt",
        "rejectedMessage": "Der Arbeiter wurde benachrichtigt und kann korrigieren.",
        "rejectionError": "Fehler",
        "rejectionErrorMessage": "Die Aufgabe kann nicht abgelehnt werden."
      },
      "history": "Verlauf",
      "deleteTask": {
        "title": "Aufgabe löschen",
        "confirm": "Möchten Sie <strong>{{name}}</strong> wirklich löschen?",
        "action": "Löschen"
      },
      "editModal": "Aufgabe bearbeiten",
      "noTasksForStep": "Keine Aufgaben für diesen Schritt.",
      "noTasksForSection": "Keine Aufgaben für diesen Abschnitt generiert.",
      "blockedMessage_one": "Vervollständigen Sie {{count}} technisches Feld, um den Arbeitsablauf zu generieren: {{fields}}.",
      "blockedMessage_other": "Vervollständigen Sie {{count}} technische Felder, um den Arbeitsablauf zu generieren: {{fields}}.",
      "blockerField": {
        "height": "Höhe",
        "substrate": "Untergrund",
        "waterproofMembrane": "Dichtungsbahn"
      },
      "completeConfiguration": "Abschnittskonfiguration vervollständigen",
      "readyToGenerate": "Dieser Abschnitt ist bereit — der Arbeitsablauf wurde noch nicht generiert.",
      "generateNow": "Aufgaben jetzt generieren",
      "ungrouped": "Aufgaben ohne Schritt",
      "taskCount_one": "{{count}} Aufgabe",
      "taskCount_other": "{{count}} Aufgaben",
      "completedCount_one": "{{count}} validiert",
      "completedCount_other": "{{count}} validiert",
      "blockedCount_one": "{{count}} blockiert",
      "blockedCount_other": "{{count}} blockiert",
      "deleteSectionTasks": {
        "title": "Alle Aufgaben im Abschnitt löschen",
        "confirm": "{{count}} Aufgabe(n) im Abschnitt <strong>{{section}}</strong> löschen? Diese Aktion ist unumkehrbar.",
        "action": "Alle löschen",
        "tooltip": "Alle Aufgaben in diesem Abschnitt löschen"
      },
      "showPast_one": "{{count}} vergangene Aufgabe anzeigen",
      "showPast_other": "{{count}} vergangene Aufgaben anzeigen",
      "showFuture_one": "{{count}} nächste Aufgabe anzeigen",
      "showFuture_other": "{{count}} nächste Aufgaben anzeigen",
      "hidePast": "Vergangene Aufgaben ausblenden",
      "hideFuture": "Nächste Aufgaben ausblenden",
      "dateFrom": "Ab dem {{date}}",
      "dateBefore": "Vor dem {{date}}",
      "stepTypes": {
        "SubstratePreparation": "Untergrundvorbereitung",
        "PrimerApplication": "Grundierung",
        "BaseLayer": "Grundschicht",
        "MeshInstallation": "Armierungsgewebe",
        "FinishingCoat": "Deckschicht",
        "Smoothing": "Glätten",
        "Presealer": "Vorverfestiger",
        "Sealer": "Versiegelung",
        "HeavyDutySealer": "HD-Versiegelung",
        "CuringStep": "Austrocknung",
        "ProtectionPeriod": "Schutzphase",
        "Handover": "Übergabe an den Kunden"
      },
      "sectionTypes": {
        "Wall": "Wand",
        "Floor": "Boden",
        "Bathroom": "Badezimmer",
        "Pool": "Pool",
        "Facade": "Fassade",
        "Steps": "Treppen",
        "Furniture": "Möbel",
        "Room": "Raum",
        "Ceiling": "Decke"
      },
      "categories": {
        "preparation": "Vorbereitung",
        "primer": "Grundierung",
        "mesh": "Armierung",
        "base_layer": "Grundschicht",
        "finishing_layer": "Deckschicht",
        "smoothing": "Glätten",
        "presealer": "Vorverfestiger",
        "sealer": "Versiegelung",
        "heavy_duty_sealer": "HD-Versiegelung",
        "curing": "Austrocknung",
        "delivery": "Lieferung",
        "inspection": "Inspektion",
        "handover": "Übergabe",
        "custom": "Benutzerdefiniert"
      },
      "priorities": {
        "low": "Niedrig",
        "normal": "Normal",
        "high": "Hoch",
        "critical": "Kritisch"
      },
      "visualStatus": {
        "pending": "Ausstehend",
        "inProgress": "In Bearbeitung",
        "review": "In Prüfung",
        "completed": "Validiert",
        "rejected": "Abgelehnt",
        "blocked": "Blockiert",
        "overdue": "Verspätet"
      },
      "blockingType": {
        "Internal": "Intern",
        "External": "Extern"
      },
      "noSectionsMessage": "Erstellen Sie einen Abschnitt, um die Projektverfolgung automatisch zu generieren.",
      "noTasksGeneratedMessage": "Keine Aufgaben generiert. Überprüfen Sie die technischen Daten Ihrer Abschnitte."
    },
    "projectType": {
      "Renovation": "Renovierungsprojekt",
      "RenovationDescription": "Sanierung bestehender Oberflächen",
      "Neuf": "Neubau",
      "NeufDescription": "Neubau und neue Oberflächen"
    },
    "sectionSource": {
      "import": "Pläne importieren",
      "importDescription": "Automatic room detection from plans",
      "manual": "Manuell erstellen",
      "manualDescription": "Definieren Sie Ihre Abschnitte einzeln"
    },
    "wizard": {
      "steps": {
        "project": "Projekt",
        "mode": "Modus",
        "type": "Typ",
        "logistics": "Logistik"
      },
      "step1": {
        "title": "Neues Projekt",
        "subtitle": "Füllen Sie die grundlegenden Informationen aus, um Ihr Projekt zu erstellen."
      },
      "step2": {
        "title": "Ausführungsmodus",
        "subtitle": "Wie wird dieses Projekt ausgeführt?"
      },
      "step3": {
        "title": "Projekttyp",
        "subtitle": "Was ist der Kontext dieses Projekts?"
      },
      "step4": {
        "title": "Baustellenzugang",
        "subtitle": "Sind große Palettenlieferungen auf dieser Baustelle möglich?"
      },
      "modes": {
        "ExternalOnly": {
          "label": "DIY-Projekt",
          "description": "Der Kunde steuert die Ausführung mit den bereitgestellten Informationen."
        },
        "MasMayaManaged": {
          "label": "Zertifizierter Applikateur",
          "description": "Projekt einem zertifizierten Mas Maya Applikateur anvertraut."
        },
        "MasMayaExecuted": {
          "label": "Mas Maya Executed",
          "description": "Projekt direkt von Mas Maya Teams ausgeführt."
        }
      },
      "types": {
        "Renovation": {
          "label": "Renovierung",
          "description": "Bestehender Untergrund, Zustand zu prüfen."
        },
        "Neuf": {
          "label": "Neubau",
          "description": "Neuer Untergrund, vorausgefüllte Parameter."
        }
      },
      "access": {
        "large": {
          "label": "Großvolumenzugang",
          "description": "Palettenlieferungen, 300 kg und 1000 kg Gebinde möglich.",
          "hint": "Baustellenzugang kompatibel mit großen Volumen und Palettenlieferungen.",
          "selectLabel": "Ja — Palettenlieferungen möglich"
        },
        "limited": {
          "label": "Eingeschränkter Zugang",
          "description": "Gebäude, Etage, kein Lastenaufzug — nur kleine Gebinde.",
          "hint": "Eingeschränkter Zugang: Großgebinde werden automatisch deaktiviert.",
          "selectLabel": "Nein — eingeschränkter Zugang, nur kleine Gebinde"
        },
        "fieldLabel": "Großvolumen-Baustellenzugang"
      }
    },
    "milestones": {
      "tabTitle": "Fortschritt",
      "empty": "Noch keine Meilensteine — sie werden automatisch generiert, sobald Abschnitte und Freigaben des Projekts fortschreiten.",
      "templates": {
        "project_started": "Projekt gestartet",
        "preparation_completed": "Vorbereitung abgeschlossen",
        "surface_approval": "Oberflächenfreigabe",
        "surface_approval_desc": "Ihre Oberfläche ist bereit für den finalen Schutz. Bitte bestätigen Sie das Finish, bevor das Schutzsystem aufgetragen wird.",
        "protection_completed": "Schutz abgeschlossen",
        "delivery": "Lieferung",
        "custom": "Neuer Meilenstein"
      },
      "status": {
        "Pending": "Ausstehend",
        "AwaitingClient": "Kundenfreigabe erforderlich",
        "Approved": "Freigegeben",
        "Completed": "Abgeschlossen",
        "Rejected": "Änderung angefordert"
      },
      "approve": "Freigeben",
      "reject": "Änderung anfordern",
      "rejectComment": "Kommentar (optional)",
      "confirmReject": "Anfrage bestätigen",
      "approvedByOn": "Genehmigt von {{name}} am {{date}}",
      "approvalStale": "Dieser Abschnitt wurde nach der Genehmigung durch den Kunden geändert – die Validierung spiegelt möglicherweise nicht mehr den aktuellen Zustand wider.",
      "clientApproval": {
        "title": "Oberflächenvalidierung",
        "description": "Ihre Oberfläche ist bereit für den finalen Schutz. Bitte bestätigen Sie das Finish, bevor das Schutzsystem aufgetragen wird."
      },
      "payment": {
        "NotDue": "Nicht fällig",
        "Due": "Fällig",
        "Paid": "Bezahlt",
        "markPaid": "Als bezahlt markieren"
      }
    },
    "holded": {
      "createEstimate": "Angebot auf Holded erstellen",
      "modalDescription": "Wählen Sie, was das Angebot \"{{name}}\" enthalten soll.",
      "creating": "Erstellen...",
      "success": "Angebot auf Holded erstellt (ID: {{id}})",
      "error": "Fehler beim Erstellen des Holded-Angebots"
    },
    "header": {
      "totalCoatingSurfaceTooltip": "Gesamtfläche zu beschichten",
      "totalCoatingSurface": "{{value}} m² zu beschichten"
    },
    "filters": {
      "allManagers": "Alle Projektleiter",
      "allExecutionModes": "Alle Ausführungsmodi",
      "lateOnly": "Nur verspätet",
      "sortBy": "Sortieren nach",
      "sort": {
        "manual": "Manuelle Reihenfolge",
        "name": "Name (A–Z)",
        "deadline": "Frist, nächste zuerst",
        "surface": "Fläche, größte zuerst",
        "progress": "Fortschritt",
        "total": "Gesamtwert"
      },
      "clearAll": "Filter zurücksetzen"
    },
    "kpi": {
      "total": "Projekte insgesamt",
      "createdThisMonth_one": "+{{count}} diesen Monat",
      "createdThisMonth_other": "+{{count}} diesen Monat",
      "shareOfBook": "{{pct}} % des Portfolios",
      "clickToIsolate": "Klicken zum Isolieren",
      "unassignedPm_one": "{{count}} ohne Projektleiter",
      "unassignedPm_other": "{{count}} ohne Projektleiter",
      "portfolioValue": "Portfoliowert",
      "pricingLoading": "Wird berechnet…",
      "incompleteCalc_one": "{{count}} unvollständige Berechnung",
      "incompleteCalc_other": "{{count}} unvollständige Berechnungen",
      "upToDate": "Vollständig kalkuliert",
      "avgProgress": "Ø Fortschritt",
      "acrossActiveWork_one": "bei {{count}} Projekt",
      "acrossActiveWork_other": "bei {{count}} Projekten"
    },
    "list": {
      "surface": "Fläche",
      "progress": "Fortschritt",
      "total": "Gesamt",
      "deadline": "Frist",
      "lateBy_one": "{{count}}T verspätet",
      "lateBy_other": "{{count}}T verspätet",
      "unassigned": "Nicht zugewiesen"
    },
    "bulk": {
      "selectedCount_one": "{{count}} ausgewählt",
      "selectedCount_other": "{{count}} ausgewählt",
      "selectAll": "Alle auswählen",
      "changeStatus": "Status ändern",
      "assignPm": "Projektleiter zuweisen",
      "changeExecutionMode": "Ausführungsmodus ändern",
      "archive": "Archivieren",
      "archiveTitle": "Projekte archivieren",
      "archiveConfirm_one": "{{count}} Projekt archivieren? Der Status kann später wieder geändert werden.",
      "archiveConfirm_other": "{{count}} Projekte archivieren? Der Status kann später wieder geändert werden.",
      "clearSelection": "Auswahl aufheben",
      "statusApplied_one": "{{count}} Projekt aktualisiert",
      "statusApplied_other": "{{count}} Projekte aktualisiert",
      "pmApplied_one": "{{count}} Projekt aktualisiert",
      "pmApplied_other": "{{count}} Projekte aktualisiert",
      "executionModeApplied_one": "{{count}} Projekt aktualisiert",
      "executionModeApplied_other": "{{count}} Projekte aktualisiert",
      "partialFailure": "{{succeeded}} aktualisiert, {{failed}} fehlgeschlagen"
    }
  },
  "contacts": {
    "title": "Kontakte",
    "createButton": "Neuer Kontakt",
    "createTitle": "Kontakt erstellen",
    "editTitle": "Kontakt bearbeiten",
    "searchPlaceholder": "Nach Name, Firma, E-Mail oder Telefon suchen...",
    "allTypes": "Alle Typen",
    "noData": "Keine Kontakte gefunden",
    "columns": {
      "name": "Name",
      "type": "Typ",
      "email": "E-Mail",
      "phone": "Telefon",
      "entity": "Entität"
    },
    "type": {
      "Individual": "Privatperson",
      "Company": "Unternehmen"
    },
    "status": {
      "active": "Aktiv",
      "inactive": "Archiviert"
    },
    "sections": {
      "general": "Allgemeine Informationen",
      "contact": "Kontaktdaten",
      "projects": "Zugehörige Projekte",
      "enrollments": "Kurssitzungen",
      "training": "Ausbildung & Zertifizierungen"
    },
    "form": {
      "entity": "Entität",
      "entityRequired": "Entität ist erforderlich",
      "type": "Typ",
      "displayName": "Anzeigename",
      "displayNameRequired": "Anzeigename ist erforderlich",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "companyName": "Firmenname",
      "email": "E-Mail",
      "phone": "Telefon",
      "addressLine1": "Adresse",
      "addressLine2": "Adresse (Zeile 2)",
      "postalCode": "Postleitzahl",
      "city": "Stadt",
      "country": "Land (ISO Alpha-2)",
      "notes": "Notizen"
    },
    "archive": {
      "title": "Kontakt archivieren",
      "confirm": "Möchten Sie \"{{name}}\" wirklich archivieren? Er wird standardmäßig nicht mehr angezeigt.",
      "action": "Archivieren"
    },
    "projectColumns": {
      "name": "Projekt",
      "status": "Status"
    },
    "enrollmentColumns": {
      "course": "Kurs",
      "date": "Datum",
      "teacher": "Lehrer",
      "status": "Status"
    },
    "installer": {
      "sectionTitle": "Referenzierter Installateur",
      "badge": "Referenzierter Installateur",
      "status": "Installateur-Status",
      "active": "Aktiv",
      "inactive": "Nicht gelistet",
      "enable": "Eintrag aktivieren",
      "disable": "Eintrag entfernen",
      "requirement": "Zertifizierung",
      "certificationLinked": "Schüler verknüpft",
      "certificationRequired": "Kein Schüler verknüpft — Zertifizierung erforderlich"
    },
    "professional": {
      "sectionTitle": "Geschäftliche Informationen",
      "siren": "SIREN",
      "sirenRequired": "SIREN ist erforderlich",
      "sirenFormat": "Die SIREN muss genau 9 Ziffern haben",
      "sirenNotFound": "Kein Unternehmen für diese SIREN gefunden",
      "vatNumber": "Umsatzsteuer-ID",
      "vatRequired": "Umsatzsteuer-ID ist erforderlich",
      "companyNameHint": "Vom Kontakt verwendeter Name (kann vom Handelsregisternamen abweichen)",
      "companyNameRequired": "Firmenname ist erforderlich",
      "legalName": "Handelsregistername",
      "registeredAddress": "Eingetragene Adresse",
      "companyStatus": "Unternehmensstatus",
      "statusRadiated": "Gelöscht",
      "director": "Geschäftsführer",
      "activity": "Geschäftstätigkeit"
    },
    "discount": {
      "sectionTitle": "Rabatt & Zertifizierung",
      "permanentDiscount": "Dauerhafter Rabatt",
      "baseDiscount": "Basisrabatt",
      "manualOverride": "Manueller Rabatt",
      "manualOverrideHint": "Überschreibt den zertifikatsbasierten Rabatt, wenn höher",
      "linkedStudent": "Verknüpfter Schüler",
      "linkedStudentHint": "Schüler-ID (UUID) für die Zertifizierungsverfolgung",
      "linked": "Verknüpft"
    },
    "hierarchy": {
      "link": "Verknüpfen",
      "linkToCompany": "Mit Unternehmen verknüpfen",
      "linkedContacts": "Verknüpfte Kontakte",
      "noLinkedContacts": "Kein individueller Kontakt verknüpft.",
      "noParentCompany": "Kein übergeordnetes Unternehmen verknüpft.",
      "parentCompany": "Mutterunternehmen",
      "selectCompany": "Unternehmen auswählen...",
      "selectIndividual": "Einzelkontakt auswählen...",
      "unlink": "Trennen",
      "unlinkConfirm": "\"{{name}}\" von diesem Unternehmen trennen?",
      "unlinkParentConfirm": "Verknüpfung mit \"{{name}}\" entfernen?",
      "unlinkTitle": "Kontakt trennen"
    }
  },
  "colors": {
    "title": "Farbauswahl",
    "colorCount": "Farben",
    "importButton": "CSV-Matrix importieren",
    "exportButton": "CSV-Matrix exportieren",
    "importSuccess": "Import erfolgreich",
    "importSuccessCount": "{{count}} Farben importiert.",
    "noData": "Keine Farbformeln geladen. Importieren Sie eine CSV-Matrix, um zu beginnen.",
    "noCollection": "Sonstige",
    "weight": "Gewicht (kg)",
    "weightHint": "Pigmentmengen passen sich dem Gewicht an",
    "coating": "Beschichtungsbasis",
    "pigments": "Pigmente",
    "productNotFound": "Produkt nicht im Katalog gefunden",
    "needed": "benötigt:",
    "unit": "Einheit",
    "subtotal": "Zwischensumme:",
    "grandTotal": "Gesamt",
    "pickColor": "Farbe wählen",
    "searchPlaceholder": "Farben suchen...",
    "noResults": "Keine Farben entsprechen Ihrer Suche",
    "removeColor": "Farbe entfernen"
  },
  "courses": {
    "enroll": {
      "search": "Kontakte suchen",
      "searchPlaceholder": "Nach Name oder E-Mail suchen...",
      "contact": "Kontakt",
      "contactPlaceholder": "Kontakt auswählen...",
      "noResults": "Keine Kontakte gefunden",
      "action": "Einschreiben"
    }
  },
  "teachers": {
    "title": "Zertifizierte Lehrkräfte",
    "createButton": "Neue Lehrkraft",
    "createTitle": "Lehrkraft hinzufügen",
    "editTitle": "Lehrkraft bearbeiten",
    "backToList": "Zurück zu den Lehrkräften",
    "searchPlaceholder": "Nach Name, E-Mail oder Land suchen...",
    "allStatuses": "Alle Status",
    "noData": "Keine Lehrkräfte gefunden",
    "inactive": "Inaktiv",
    "noCertifiedLevels": "Keine zertifizierten Niveaus",
    "columns": {
      "name": "Name",
      "certification": "Zertifizierung",
      "levels": "Zertifizierte Niveaus",
      "languages": "Sprachen",
      "validity": "Gültig bis"
    },
    "certificationStatus": {
      "Pending": "Ausstehend",
      "Active": "Aktiv",
      "Expired": "Abgelaufen",
      "Revoked": "Widerrufen"
    },
    "form": {
      "fullName": "Vollständiger Name",
      "fullNameRequired": "Name ist erforderlich",
      "email": "E-Mail",
      "emailRequired": "E-Mail ist erforderlich",
      "country": "Land (ISO Alpha-2)",
      "languages": "Sprachen",
      "certifiedLevels": "Zertifizierte Niveaus",
      "specialties": "Spezialgebiete",
      "specialtiesPlaceholder": "Pool, Außen...",
      "isActive": "Aktive Lehrkraft"
    },
    "certify": {
      "title": "Lehrkraft zertifizieren",
      "action": "Zertifizieren",
      "levels": "Zu zertifizierende Niveaus",
      "levelsRequired": "Mindestens ein Niveau auswählen",
      "certificationDate": "Zertifizierungsdatum",
      "expirationDate": "Ablaufdatum",
      "expirationRequired": "Ablaufdatum ist erforderlich",
      "selfCertifyNote": "Eine Lehrkraft kann sich nicht selbst zertifizieren. Diese Aktion ist Mas Maya-Administratoren vorbehalten.",
      "expired": "Zertifizierung abgelaufen"
    },
    "revoke": {
      "title": "Zertifizierung widerrufen",
      "confirm": "Zertifizierung dieser Lehrkraft widerrufen? Sie kann keine Sitzungen mehr leiten.",
      "action": "Widerrufen"
    },
    "info": {
      "certification": "Zertifizierung",
      "profile": "Profil",
      "certifiedOn": "Zertifiziert am",
      "expiresOn": "Läuft ab am"
    },
    "sessions": {
      "title": "Zugewiesene Sitzungen",
      "empty": "Keine zugewiesenen Sitzungen"
    },
    "evaluations": {
      "title": "Schülerbewertungen",
      "student": "Schüler",
      "score": "Bewertung",
      "notes": "Anmerkungen",
      "date": "Datum"
    },
    "evaluate": {
      "title": "Schüler bewerten",
      "addButton": "Bewertung hinzufügen",
      "action": "Einreichen",
      "student": "Schüler",
      "studentPlaceholder": "Schüler auswählen...",
      "noStudents": "Keine Schüler gefunden",
      "score": "Bewertung (1–5)",
      "scoreHint": "1 = verbesserungswürdig, 5 = ausgezeichnet",
      "notes": "Anmerkungen"
    }
  },
  "students": {
    "title": "Lernende",
    "createButton": "Neuer Lernender",
    "createTitle": "Lernenden hinzufügen",
    "searchPlaceholder": "Nach Name oder E-Mail suchen...",
    "noData": "Keine Lernenden gefunden",
    "type": {
      "Individual": "Privatperson",
      "Professional": "Fachkraft"
    },
    "columns": {
      "name": "Name",
      "email": "E-Mail",
      "type": "Typ",
      "company": "Unternehmen",
      "country": "Land",
      "language": "Sprache"
    },
    "form": {
      "firstName": "Vorname",
      "firstNameRequired": "Vorname ist erforderlich",
      "lastName": "Nachname",
      "lastNameRequired": "Nachname ist erforderlich",
      "email": "E-Mail",
      "emailRequired": "E-Mail ist erforderlich",
      "phone": "Telefon",
      "type": "Typ",
      "companyName": "Firmenname"
    }
  },
  "certifications": {
    "title": "Applikator-Zertifizierungen",
    "allLevels": "Alle Stufen",
    "allStatuses": "Alle Status",
    "searchPlaceholder": "Nach Name oder E-Mail suchen...",
    "noData": "Keine Zertifizierungen gefunden",
    "viewLevels": "Stufen anzeigen",
    "publicPage": "Öffentliche Seite",
    "status": {
      "Pending": "Ausstehend",
      "Passed": "Bestanden",
      "Failed": "Nicht bestanden",
      "Expired": "Abgelaufen"
    },
    "columns": {
      "student": "Lernender",
      "level": "Stufe",
      "status": "Status",
      "issuedAt": "Ausgestellt am",
      "expiration": "Gültig bis",
      "session": "Sitzung",
      "finishes": "Expert-Oberflächen",
      "certifications": "Zertifizierungen"
    },
    "issue": {
      "title": "Zertifizierung ausstellen",
      "action": "Ausstellen",
      "levelRequired": "Stufe ist erforderlich",
      "level": "Zertifizierungsstufe",
      "issuedAt": "Ausstellungsdatum",
      "expirationDate": "Ablaufdatum",
      "notes": "Notizen",
      "basicNote": "Basic-Zertifizierungen werden nach vollständiger Teilnahme automatisch validiert und können nicht als nicht bestanden markiert werden.",
      "allLevelsIssued": "Dieser Lernende hat bereits für alle Stufen eine Zertifizierung.",
      "alreadyIssued": "Zertifizierung für dieses Niveau bereits ausgestellt",
      "absentCannotIssue": "Einer abwesenden Person kann keine Zertifizierung ausgestellt werden",
      "expertFinishes": "Expert-Oberflächen validiert",
      "terrazzoMetadata": "Terrazzo — Basis + 3 Einlegefarben",
      "terrazzoPlaceholder": "z.B. Weiß Basis, Schwarz, Gold, Rost"
    },
    "update": {
      "title": "Zertifizierung aktualisieren",
      "action": "Speichern",
      "status": "Status",
      "addFinish": "Expert-Oberfläche validieren",
      "selectFinish": "Oberfläche auswählen...",
      "validateFinish": "Oberfläche validieren"
    },
    "levels": {
      "title": "Applikator-Zertifizierungsstufen",
      "subtitle": "Anforderungen und Anwendungsbereich je Stufe",
      "skills": "Anwendungsbereich",
      "products": "Erforderliche Produkte",
      "finishes": "Kreativoberflächen",
      "canFail": "Kann nicht bestanden werden",
      "cannotFail": "Kann nicht durchgefallen werden",
      "autoValidates": "Automatische Validierung"
    },
    "levelDefinitions": {
      "basic": {
        "title": "Basis-Applikator",
        "skills": {
          "interiorWalls": "Innenwände",
          "interiorFloors": "Innenböden",
          "interiorCeilings": "Innendecken",
          "cleanStableSubstrates": "Saubere, stabile Untergründe"
        }
      },
      "intermediate": {
        "title": "Applikator Mittelstufe",
        "skills": {
          "protectedExteriors": "Geschützte Außenbereiche",
          "complexInteriors": "Komplexe Innenbereiche",
          "deterioratedSubstrates": "Beschädigte Untergründe",
          "correctivePrep": "Korrigierende Vorbereitung"
        }
      },
      "expert": {
        "title": "Experten-Applikator",
        "skills": {
          "wetRooms": "Feuchträume",
          "showers": "Duschen",
          "bathtubs": "Badewannen",
          "pools": "Pools",
          "fountains": "Brunnen",
          "facades": "Fassaden",
          "wetAreas": "Feuchtbereiche"
        }
      },
      "expertFinishes": {
        "title": "Experten-Applikator für Oberflächen",
        "skills": {
          "advancedCreativeFinishes": "Fortgeschrittene und kreative Oberflächen"
        },
        "finishes": {
          "pise": "Pisé (Stampflehm)",
          "castConcreteAcetate": "Gegossener Beton (Acetat)",
          "woodFormworkConcrete": "Beton mit Holzschalung",
          "burntEffect": "Brenneffekt",
          "brushedConcrete": "Gebürsteter Beton",
          "rawSandEffect": "Roher Sandeffekt",
          "shouSugiBan": "Shou Sugi Ban",
          "naturalStoneEffect": "Natursteineffekt",
          "terrazzoEffect": "Terrazzo-Effekt (Basis + 3 Einlagen)"
        }
      },
      "products": {
        "preparation": "Vorbereitung",
        "base": "Basis"
      }
    },
    "public": {
      "subtitle": "{{count}} validierte Zertifizierung(en)",
      "noData": "Keine Zertifizierungen für diesen Applikator gefunden.",
      "footer": "Zertifiziert von Mas Maya · masmaya.fr"
    },
    "admin": {
      "newDefinition": "Neue Definition",
      "editDefinition": "Definition bearbeiten",
      "noDefinitions": "Keine Definitionen.",
      "form": {
        "name": "Name",
        "slug": "Slug",
        "slugDescription": "Eindeutiger URL-Bezeichner (z.B. basic-applicator)",
        "category": "Kategorie",
        "prerequisites": "Voraussetzungen",
        "description": "Beschreibung",
        "sortOrder": "Anzeigereihenfolge",
        "isActive": "Aktiv"
      },
      "columns": {
        "name": "Name",
        "slug": "Slug",
        "category": "Kategorie",
        "prerequisites": "Voraussetzungen",
        "order": "Reihenfolge",
        "active": "Aktiv"
      }
    }
  },
  "finishEvaluation": {
    "modalTitle": "Expert-Oberflächen-Bewertung",
    "evaluateAction": "Oberfläche bewerten",
    "finishType": "Oberflächen-Typ",
    "finishPlaceholder": "Oberfläche auswählen...",
    "finishRequired": "Bitte wählen Sie einen Oberflächen-Typ",
    "score": "Punktzahl (0–10)",
    "willFail": "Unter dem Bestehens-Schwellenwert",
    "photos": "Fotos",
    "photosBefore": "Vorher-Fotos",
    "photosDuring": "Während-Fotos",
    "photosAfter": "Nachher-Fotos",
    "dropPhotos": "Bilder ablegen oder klicken zum Durchsuchen",
    "photosRequired": "Mindestens ein Vorher-Foto und ein Nachher-Foto sind erforderlich",
    "terrazzoColors": "Terrazzo-Farben",
    "terrazzoBase": "Grundfarbe",
    "terrazzoColor1": "Einlage 1",
    "terrazzoColor2": "Einlage 2",
    "terrazzoColor3": "Einlage 3",
    "terrazzoColorsRequired": "Alle vier Terrazzo-Farben sind erforderlich",
    "submit": "Bewertung einreichen",
    "uploading": "Fotos werden hochgeladen…",
    "historyTitle": "Expert-Oberflächen-Bewertungen",
    "attempts": "{{count}} Versuch(e)",
    "finishes": {
      "Pise": {
        "label": "Pisé-Effekt",
        "description": "Schichtweise Verdichtung nach traditioneller Pisé-Technik."
      },
      "BetonCoule": {
        "label": "Acetat-Gussbeton",
        "description": "Beton mit Acetatfolie gegossen für einen glatten, glänzenden Effekt."
      },
      "BetonCoffrage": {
        "label": "Holzschalungsbeton",
        "description": "Holzbretter-Abdruck im Beton für eine strukturierte Textur."
      },
      "EffetBrule": {
        "label": "Verbrannter Effekt",
        "description": "Sehr fester Stein oder Edelstahlkelle für eine verbrannte Textur."
      },
      "BetonBrosse": {
        "label": "Gebürsteter Beton",
        "description": "Bürsten von frischem Beton für eine texturierte Oberfläche mit Rillen."
      },
      "EffetBrut": {
        "label": "Roher Effekt mit Sandspuren",
        "description": "Rohe Oberfläche mit sichtbaren Sandspuren."
      },
      "ShouSugiBan": {
        "label": "Verkohltes Holz Shou Sugi Ban",
        "description": "Japanische Holzverbrennungstechnik beim Ausschalen."
      },
      "EffetPierre": {
        "label": "Naturstein-Effekt",
        "description": "Imitation der Textur und des Aussehens von Naturstein."
      },
      "EffetTerrazzo": {
        "label": "Terrazzo-Effekt",
        "description": "Terrazzo mit Grundfarbe und 3 farbigen Einlagen."
      }
    }
  },
  "certificates": {
    "title": "Digitale Zertifikate",
    "status": {
      "Active": "Aktiv",
      "Expired": "Abgelaufen",
      "Revoked": "Widerrufen"
    },
    "verify": {
      "title": "Zertifikatsverifizierung",
      "code": "Verifizierungscode",
      "level": "Zertifizierungsstufe",
      "specialties": "Spezialitäten",
      "issued": "Ausgestellt am",
      "expires": "Läuft ab am",
      "revokedOn": "Widerrufen am",
      "validNote": "Dieses Zertifikat wurde von Mas Maya ausgestellt und ist online verifizierbar.",
      "notFound": "Zertifikat nicht gefunden",
      "notFoundDesc": "Kein Zertifikat mit diesem Verifizierungscode gefunden.",
      "link": "Verifizieren"
    },
    "revoke": {
      "title": "Zertifikat widerrufen",
      "confirm": "Sind Sie sicher, dass Sie dieses Zertifikat widerrufen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
      "action": "Widerrufen",
      "defaultReason": "Widerrufen durch Administrator"
    }
  },
  "evaluation": {
    "modalTitle": "Zertifizierungsbewertung",
    "evaluateCertification": "Zertifizierung bewerten",
    "selectStudent": "Lernender",
    "studentPlaceholder": "Lernenden auswählen...",
    "studentRequired": "Bitte einen Lernenden auswählen",
    "criteria": "Bewertungskriterien",
    "scoreRange": "Bewertung 0–10",
    "finalScore": "Gesamtnote",
    "willPass": "Wird bestehen",
    "willFail": "{{count}} Kriterium/Kriterien unzureichend",
    "failAlert": "Folgende Kriterien sind unter dem Schwellenwert: {{criteria}}",
    "teacherNotes": "Anmerkungen der Lehrkraft",
    "notesPlaceholder": "Beobachtungen, Verbesserungspunkte...",
    "noCriteria": "Keine Kriterien für dieses Niveau definiert",
    "submit": "Bewertung einreichen",
    "history": "Bewertungsverlauf",
    "passed": "Bestanden",
    "failed": "Nicht bestanden",
    "failedCriteria": "Nicht bestandene Kriterien",
    "retrySessions": "Verfügbare Wiederholungssitzungen",
    "seats": "Plätze"
  },
  "dashboard": {
    "title": "Dashboard",
    "subtitle": "Übersicht Ihrer Schulungsaktivitäten",
    "upcomingSessions": "Kommende Sitzungen",
    "stats": {
      "students": "Lernende",
      "teachers": "Lehrkräfte",
      "activeCerts": "Aktive Zertifikate",
      "pendingCerts": "Ausstehend",
      "upcomingSessions": "Demnächst (30T)",
      "passedThisYear": "Bestanden dieses Jahr"
    },
    "projectsOverview": {
      "title": "Projekte",
      "active": "Aktiv",
      "blocked": "Blockiert",
      "awaitingValidation": "Wartet auf Genehmigung",
      "late": "Verspätet",
      "needsAttention": "Benötigt Ihre Aufmerksamkeit"
    }
  },
  "teacherDashboard": {
    "welcomeLabel": "Willkommen",
    "noProfile": "Kein Lehrerprofil",
    "noProfileDesc": "Ihrem Konto ist kein Lehrerprofil zugeordnet.",
    "upcomingSessions": "Ihre kommenden Sitzungen",
    "recentEvaluations": "Aktuelle Bewertungen",
    "noSessions": "Keine Sitzungen zugewiesen",
    "stats": {
      "upcoming": "Demnächst",
      "sessions": "Sitzungen gesamt",
      "evaluations": "Bewertungen"
    }
  },
  "studentPortal": {
    "title": "Lernendenbereich",
    "subtitle": "Greifen Sie auf Ihre Schulungsergebnisse, Zertifikate und kommende Sitzungen zu.",
    "emailLabel": "Ihre E-Mail-Adresse",
    "emailPlaceholder": "lernende@beispiel.de",
    "lookup": "Mein Profil aufrufen",
    "notFound": "Kein Konto gefunden",
    "profileLabel": "Mein Profil",
    "profileNotFound": "Profil nicht gefunden",
    "upcomingSessions": "Kommende Sitzungen",
    "pastSessions": "Vergangene Sitzungen",
    "footer": "Mas Maya Schulung · masmaya.fr",
    "privacyNote": "Es werden nur Ihre Schulungsdaten angezeigt. Kein Konto oder Passwort erforderlich."
  },
  "enroll": {
    "title": "Für eine Sitzung anmelden",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "email": "E-Mail-Adresse",
    "type": "Typ",
    "company": "Unternehmen / Organisation",
    "country": "Land (2-Buchstaben-Code)",
    "language": "Bevorzugte Sprache",
    "seatsLeft": "{{count}} Platz/Plätze verfügbar",
    "submit": "Anmelden",
    "requiredFields": "Bitte füllen Sie alle Pflichtfelder aus.",
    "notOpen": "Anmeldung nicht geöffnet",
    "notOpenDesc": "Diese Sitzung ist derzeit nicht für Anmeldungen geöffnet.",
    "sessionNotFound": "Sitzung nicht gefunden",
    "successTitle": "Anmeldung bestätigt!",
    "successDesc": "Ihr Platz ist reserviert. Sie erhalten eine Bestätigung per E-Mail.",
    "viewProfile": "Mein Profil anzeigen",
    "error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    "privacyNote": "Ihre Daten werden ausschließlich zu Schulungszwecken verwendet.",
    "professional": {
      "siren": "SIREN-Nummer",
      "sirenDesc": "9 Ziffern — automatische Suche über Pappers",
      "sirenRequired": "SIREN-Nummer ist erforderlich (9 Ziffern).",
      "sirenNotFound": "Unternehmen nicht gefunden oder ungültige SIREN.",
      "vatNumber": "USt-IdNr.",
      "vatRequired": "USt-IdNr. ist erforderlich.",
      "companyRequired": "Unternehmensname ist erforderlich.",
      "companyNameDesc": "Handelsname (kann vom Firmennamen abweichen)",
      "director": "Geschäftsführer",
      "radiated": "Unternehmen aufgelöst / geschlossen"
    }
  },
  "entities": {
    "title": "Entitäten",
    "createButton": "Neue Entität",
    "createTitle": "Entität erstellen",
    "editTitle": "Entität bearbeiten",
    "searchPlaceholder": "Nach Name, Code oder Land suchen...",
    "showArchived": "Archivierte anzeigen",
    "noData": "Keine Entitäten gefunden",
    "noUsers": "Keine Benutzer zugewiesen",
    "viewUsers": "Benutzer anzeigen",
    "columns": {
      "name": "Name",
      "code": "Code",
      "country": "Land",
      "status": "Status",
      "users": "Benutzer"
    },
    "status": {
      "active": "Aktiv",
      "inactive": "Inaktiv"
    },
    "sections": {
      "general": "Allgemeine Informationen",
      "users": "Zugewiesene Benutzer",
      "staff": "Mitarbeiter"
    },
    "noStaff": "Keine Mitarbeiter für diese Entität",
    "form": {
      "name": "Name",
      "nameRequired": "Name ist erforderlich",
      "code": "Interner Code",
      "codePlaceholder": "z.B. CORP-DE",
      "country": "Land (ISO Alpha-2)",
      "countryPlaceholder": "Land auswählen",
      "countryRequired": "Land ist erforderlich",
      "currency": "Währung (ISO 4217)",
      "timezone": "Zeitzone",
      "email": "Kontakt-E-Mail",
      "logoUrl": "Logo-URL",
      "isActive": "Aktiv"
    },
    "archive": {
      "title": "Entität archivieren",
      "confirm": "Möchten Sie \"{{name}}\" wirklich archivieren?",
      "confirm_action": "Archivieren"
    },
    "assignUser": {
      "title": "Benutzer zuweisen",
      "button": "Benutzer zuweisen",
      "searchLabel": "Benutzer suchen",
      "searchPlaceholder": "Name oder E-Mail...",
      "noResults": "Keine Benutzer gefunden",
      "selected": "Ausgewählt",
      "assign": "Zuweisen"
    },
    "removeUser": {
      "title": "Benutzer entfernen",
      "confirm": "{{name}} aus dieser Entität entfernen?"
    },
    "managers": {
      "title": "Verantwortliche",
      "role": "Entitätsmanager",
      "noAvailable": "Keine Benutzer verfügbar"
    },
    "userColumns": {
      "name": "Name",
      "email": "E-Mail",
      "assignedOn": "Zugewiesen am"
    },
    "quoteConfig": {
      "title": "Angebotskonfiguration",
      "subtitle": "Standardwerte für die Verbrauchsberechnung",
      "consumptionRates": "Verbrauchsraten",
      "wasteFactors": "Verlustfaktoren",
      "labourRates": "Arbeitskosten",
      "complexityMultipliers": "Komplexitätsmultiplikatoren",
      "fields": {
        "coating1LayerKgPerM2": "Beschichtung 1 Schicht",
        "coating2LayerKgPerM2": "Beschichtung 2 Schichten",
        "mixingWaterWallLPerKg": "Anmachwasser Wand",
        "mixingWaterFloorLPerKg": "Anmachwasser Boden",
        "prepCoverageM2Per10Kg": "Prep",
        "primerCoverageM2PerL": "Primer",
        "poolPrimerCoverageM2PerL": "Pool Primer",
        "presealerCoverageM2PerL": "Presealer",
        "sealerCoverageM2PerL": "Sealer",
        "heavyDutySealerCoverageM2PerL": "Heavy-Duty Sealer",
        "meshWasteFactor": "Mesh-Verlust (einfach)",
        "meshComplexWasteFactor": "Mesh-Verlust (komplex)",
        "generalWasteFactor": "Allgemeiner Verlust",
        "labourRatePerM2": "Satz / m²",
        "labourRatePerSurface": "Satz / Fläche",
        "labourRatePerProduct": "Satz / Produkt",
        "complexityLow": "Niedrig",
        "complexityNormal": "Normal",
        "complexityMedium": "Mittel",
        "complexityHigh": "Hoch",
        "repairMinSurfaceM2": "Mindestfläche Reparatur (m²)",
        "prepMarginPercent": "Marge Prep",
        "primerMarginPercent": "Marge Primer",
        "poolPrimerMarginPercent": "Marge Pool Primer",
        "coatingMarginPercent": "Marge Coating",
        "meshMarginPercent": "Marge Mesh",
        "presealerMarginPercent": "Marge Presealer",
        "sealerMarginPercent": "Marge Sealer",
        "heavyDutySealerMarginPercent": "Marge HD Sealer",
        "pigmentMarginPercent": "Marge Pigmente"
      },
      "siteLogistics": "Baustellenlogistik",
      "maxSmallAccessCoatingBag": "Max. Coating-Sackgröße ohne Großvolumenzugang",
      "materialMargin": "Materialmargen",
      "markups": {
        "title": "Baustellenzuschläge",
        "occupiedSite": "Belegte Baustelle (%)",
        "furnishedRoom": "Möblierter Raum (%)",
        "standardFinishDiscount": "Rabatt Standardfinish (%)",
        "standardFinishDiscountHint": "Die Grundarbeitskosten sind für Premium-Finish kalibriert. Dieser Rabatt gilt, wenn die Finish einer Sektion Standard ist."
      },
      "degressiveRates": "Degressive Arbeitskostensätze pro m²",
      "addTier": "Stufe hinzufügen",
      "tierFields": {
        "minSurface": "Mindestfläche",
        "maxSurface": "Höchstfläche",
        "rate": "Satz (€/m²)",
        "enabled": "Aktiv"
      },
      "taskGenConfig": {
        "title": "Aufgabengenerierungsvariablen",
        "save": "Variablen speichern",
        "saveSuccess": "Aufgabengenerierungsvariablen gespeichert.",
        "saveError": "Speichern fehlgeschlagen.",
        "unsavedWarning": "Nicht gespeicherte Änderungen. Klicken Sie auf Speichern, um sie auf zukünftige Generierungen anzuwenden.",
        "critical": "Kritisch",
        "taskFamilies": {
          "title": "Aufgabenfamilien aktivieren",
          "description": "Das Deaktivieren einer Familie verhindert, dass diese Aufgaben in neuen Projekten generiert werden. Vorhandene Aufgaben werden nicht entfernt.",
          "preparation": "Untergrundvorbereitung",
          "primer": "Primer",
          "mesh": "Mesh / Gitter",
          "coating": "Deckschichten",
          "drying": "Trocknungszeit",
          "presealer": "Presealer",
          "sealer": "Sealer",
          "heavyDuty": "Heavy-Duty Sealer",
          "qualityControl": "Qualitätskontrolle",
          "aftercare": "Aftercare / Schutz",
          "handover": "Kundenübergabe (Handover)"
        },
        "substratePrep": {
          "title": "Untergrundvorbereitung",
          "inspection": "Untergrundinspektion",
          "surfaceCleaning": "Oberflächenreinigung",
          "sanding": "Schleifen",
          "dustRemoval": "Entstauben",
          "maskingProtection": "Schutz angrenzender Bereiche",
          "crackTreatment": "Rissbehandlung",
          "jointTreatment": "Fugenbehandlung",
          "maxImperfectionMm": "Max. Unebenheit",
          "maxImperfectionHint": "Schwelle, ab der eine Füllaufgabe generiert wird"
        },
        "primer": {
          "title": "Primer",
          "minWaitMinutes": "Min. Wartezeit — Standard-Primer",
          "minWaitHint": "Mindestwartezeit vor dem Auftragen der ersten Schicht",
          "maxWindowHours": "Max. Fenster — Standard-Primer",
          "maxWindowHint": "Die Schicht muss vor dieser Zeit aufgetragen werden",
          "poolMinWaitMinutes": "Min. Wartezeit — Pool-Primer",
          "poolMinWaitHint": "Pool Primer — Mindestwartezeit vor Coating"
        },
        "mixing": {
          "title": "Mischung und Schichten",
          "mixRestMinutes": "Ruhezeit Mischung",
          "mixRestHint": "Ruhezeit nach dem Mischen vor dem Auftragen",
          "wallWaterRatio": "Wasser-Verhältnis Wand",
          "floorWaterRatio": "Wasser-Verhältnis Boden",
          "baseLayerThickness": "Grundschichtdicke",
          "finishLayerThickness": "Deckschichtdicke"
        },
        "mesh": {
          "title": "Mesh / Gitter",
          "overlapCm": "Mesh-Überlappung",
          "edgeDistanceCm": "Mesh-Randabstand",
          "requiredFor": "Mesh erforderlich für",
          "floors": "Böden",
          "stairs": "Treppen",
          "tiles": "Fliesen",
          "wood": "Holz",
          "pools": "Pools",
          "bathrooms": "Badezimmer",
          "exteriors": "Fassaden / Außen"
        },
        "waterproofing": {
          "title": "Abdichtung",
          "description": "Der Mas Maya Belag ist wasserresistent, aber nicht wasserdicht. In folgenden Fällen ist eine Abdichtungsmembrane erforderlich.",
          "wetZones": "Membrane erforderlich — Nassbereiche",
          "wetZonesHint": "Nassbereiche, direkter Wasserkontakt",
          "pools": "Membrane erforderlich — Pools",
          "bathrooms": "Membrane erforderlich — Badezimmer"
        },
        "presealer": {
          "title": "Presealer",
          "numberOfCoats": "Anzahl Schichten",
          "waitBetweenCoats": "Wartezeit zwischen Schichten"
        },
        "sealer": {
          "title": "Standard Sealer",
          "ratioA": "Ratio A",
          "ratioAHint": "Teil A der Mischung (z.B. 5)",
          "ratioB": "Ratio B",
          "ratioBHint": "Teil B der Mischung (z.B. 1)",
          "mixRestMinutes": "Ruhezeit Mischung",
          "numberOfCoats": "Anzahl Schichten",
          "waitBetweenCoats": "Wartezeit zwischen Schichten",
          "fullCureHours": "Vollständige Aushärtung"
        },
        "heavyDuty": {
          "title": "Heavy-Duty Sealer",
          "ratioA": "Ratio A",
          "ratioB": "Ratio B",
          "waitBetweenCoats": "Wartezeit zwischen Schichten",
          "fullCureHours": "Vollständige Aushärtung",
          "minTempC": "Min. Anwendungstemperatur",
          "maxTempC": "Max. Anwendungstemperatur",
          "requiredFor": "Heavy-Duty erforderlich für",
          "floors": "Böden",
          "stairs": "Treppen",
          "exteriors": "Außen",
          "pools": "Pools",
          "highTraffic": "Hochbelastete Bereiche"
        },
        "pool": {
          "title": "Pool-Regeln",
          "fillWaitDays": "Wartezeit vor dem Befüllen",
          "fillWaitHint": "Mindestdauer vor dem Befüllen des Pools",
          "waterlineMarginCm": "HD-Wasserlinie-Marge",
          "waterlineMarginHint": "Breite der Heavy-Duty-Zone um die Wasserlinie"
        },
        "exterior": {
          "title": "Außenbereich-Regeln",
          "minTempC": "Min. Temperatur",
          "maxTempC": "Max. Temperatur"
        },
        "aftercare": {
          "title": "Aftercare und Nutzungsbeschränkungen",
          "noWaterDays": "Absoluter Schutz",
          "noWaterHint": "Kein Kontakt oder Feuchtigkeit",
          "noTrafficDays": "Kein Verkehr",
          "lightUseStartDay": "Leichte Nutzung ab Tag",
          "normalUseAfterDays": "Normale Nutzung nach",
          "resealYearsMin": "Re-Sealing empfohlen innerhalb von",
          "resealYearsMax": "Re-Sealing empfohlen vor"
        },
        "layerExceptions": {
          "title": "Einzel-/Doppelschicht-Ausnahmen",
          "description": "Das Standard-Mas-Maya-System ist 2 mm Grundschicht + Mesh + 2 mm Finish. Diese Ausnahmen sollten nur für ideale trockene Innenflächen aktiviert werden.",
          "allowOneLayer": "Einschicht-System ohne Mesh erlauben",
          "allowOneLayerHint": "Nur perfekte trockene Innenwände",
          "oneLayerWalls": "Einschicht auf Wänden erlaubt",
          "oneLayerCeilings": "Einschicht auf Decken erlaubt",
          "allowTwoLayer": "Zweischicht-System ohne Mesh erlauben",
          "allowTwoLayerHint": "Nur stabile strukturierte Wände",
          "twoLayerStableWalls": "Zweischicht ohne Mesh auf stabilen strukturierten Wänden"
        },
        "underfloorHeating": {
          "title": "Fußbodenheizung",
          "warning": "Das Ändern der Neustartparameter kann die Beschichtungsleistung beeinflussen. Ändern Sie diese Werte nur gemäß der technischen Mas Maya Dokumentation.",
          "generationTitle": "Generierung",
          "generateTasks": "Fußbodenheizungsaufgaben generieren",
          "requireQuestion": "Heizungsfrage für Bodenabschnitte stellen",
          "generateShutdown": "Aufgabe Heizungsabschaltung",
          "generateRestart": "Aufgaben Heizungsneustart",
          "generateProgressiveHeatUp": "Progressives Aufheizen (Aufgaben pro Tag)",
          "generateMonitoring": "Temperaturüberwachungsaufgaben",
          "generateClientHandover": "Kundenanweisungen übergeben",
          "shutdownTitle": "Abschaltung vor Anwendung",
          "shutdownBeforeApplication": "Abschaltstunden vor Anwendung",
          "shutdownBeforeSealer": "Abschaltstunden vor Sealer",
          "offDuringApplication": "Heizung während Anwendung aus",
          "offDuringCure": "Heizung während Aushärtung aus",
          "restartTitle": "Progressiver Neustart",
          "restartAfterSealer": "Wartezeit nach letztem Sealer vor Neustart",
          "restartStartTemp": "Starttemperatur",
          "restartTempIncrement": "Tägliche Erhöhung",
          "restartMaxTemp": "Maximaltemperatur",
          "restartMinDuration": "Mindest-Aufheizzeit",
          "restartRequiresValidation": "Validierung bei Abschluss erforderlich",
          "controlsTitle": "Kontrollen",
          "dailyTempCheck": "Tägliche Temperaturkontrolle",
          "floorSurfaceTempCheck": "Bodenflächentemperaturkontrolle vor Neustart",
          "clientWarningRapidHeatUp": "Kundenwarnung bei schnellem Aufheizen",
          "restartCompletionQc": "Abschlusskontrolle nach Neustart"
        }
      }
    },
    "taskGenConfig": {
      "title": "Aufgabengenerierungs-Variablen",
      "save": "Variablen speichern",
      "saveError": "Speichern fehlgeschlagen.",
      "saveSuccess": "Generierungsvariablen gespeichert.",
      "critical": "kritisch",
      "unsavedWarning": "Ungespeicherte Änderungen. Klicken Sie auf Speichern, um sie auf künftige Generierungen anzuwenden.",
      "aftercare": {
        "title": "Aftercare und Nutzungsbeschränkungen",
        "lightUseStartDay": "Leichte Nutzung ab Tag",
        "noTrafficDays": "Kein Verkehr",
        "noWaterDays": "Absoluter Schutz",
        "noWaterHint": "Kein Kontakt oder Feuchtigkeit",
        "normalUseAfterDays": "Normale Nutzung nach",
        "resealYearsMax": "Nachversiegelung empfohlen bis",
        "resealYearsMin": "Nachversiegelung empfohlen ab"
      },
      "exterior": {
        "title": "Außenregeln",
        "maxTempC": "Max. Temperatur",
        "minTempC": "Min. Temperatur"
      },
      "heavyDuty": {
        "title": "Heavy-Duty Sealer",
        "exteriors": "Außenbereiche",
        "floors": "Böden",
        "fullCureHours": "Vollständige Aushärtung",
        "highTraffic": "Bereich mit hohem Verkehr",
        "maxTempC": "Max. Verarbeitungstemperatur",
        "minTempC": "Min. Verarbeitungstemperatur",
        "pools": "Schwimmbäder",
        "ratioA": "Verhältnis A",
        "ratioB": "Verhältnis B",
        "requiredFor": "Heavy-Duty erforderlich für",
        "stairs": "Treppen",
        "waitBetweenCoats": "Wartezeit zwischen Schichten"
      },
      "layerExceptions": {
        "title": "Mono/Zweischicht-Ausnahmen",
        "description": "Das Standard-Mas-Maya-System ist 2 mm Grundschicht + Mesh + 2 mm Finish. Diese Ausnahmen nur für ideale Innenflächen in trockener Umgebung aktivieren.",
        "allowOneLayer": "Einschichtsystem ohne Mesh erlauben",
        "allowOneLayerHint": "Nur für perfekte, trockene Innenwände",
        "allowTwoLayer": "Zweischicht ohne Mesh erlauben",
        "allowTwoLayerHint": "Nur für stabile texturierte Wände",
        "oneLayerCeilings": "Einschicht auf Decken erlaubt",
        "oneLayerWalls": "Einschicht auf Wänden erlaubt",
        "twoLayerStableWalls": "Zweischicht ohne Mesh auf stabilen texturierten Wänden"
      },
      "mesh": {
        "title": "Mesh / Gewebe",
        "bathrooms": "Badezimmer",
        "edgeDistanceCm": "Mesh-Randabstand",
        "exteriors": "Fassaden / Außen",
        "floors": "Böden",
        "overlapCm": "Mesh-Überlappung",
        "pools": "Schwimmbäder",
        "requiredFor": "Mesh erforderlich für",
        "stairs": "Treppen",
        "tiles": "Fliesen",
        "wood": "Holz"
      },
      "mixing": {
        "title": "Mischung und Schichten",
        "baseLayerThickness": "Grundschichtdicke",
        "finishLayerThickness": "Finishschichtdicke",
        "floorWaterRatio": "Wasser-Boden-Verhältnis",
        "mixRestHint": "Ruhezeit nach dem Mischen vor der Anwendung",
        "mixRestMinutes": "Mischruhezeit",
        "wallWaterRatio": "Wasser-Wand-Verhältnis"
      },
      "pool": {
        "title": "Pool-Regeln",
        "fillWaitDays": "Wartezeit vor dem Befüllen",
        "fillWaitHint": "Mindestdauer vor dem Befüllen des Pools",
        "waterlineMarginCm": "Wasserlinie HD-Marge",
        "waterlineMarginHint": "Breite der Heavy-Duty-Zone um die Wasserlinie"
      },
      "presealer": {
        "title": "Presealer",
        "numberOfCoats": "Anzahl der Schichten",
        "waitBetweenCoats": "Wartezeit zwischen Schichten"
      },
      "primer": {
        "title": "Primer",
        "maxWindowHint": "Die Schicht muss innerhalb dieser Zeit aufgetragen werden",
        "maxWindowHours": "Max. Standard-Primer-Fenster",
        "minWaitHint": "Mindestwartezeit vor Auftrag der ersten Schicht",
        "minWaitMinutes": "Min. Wartezeit Standard-Primer",
        "poolMinWaitHint": "Pool Primer — Mindestwartezeit vor Coating",
        "poolMinWaitMinutes": "Min. Wartezeit Pool-Primer"
      },
      "sealer": {
        "title": "Standard-Sealer",
        "fullCureHours": "Vollständige Aushärtung",
        "mixRestMinutes": "Mischruhezeit",
        "numberOfCoats": "Anzahl der Schichten",
        "ratioA": "Verhältnis A",
        "ratioAHint": "Teil A der Mischung (z. B.: 5)",
        "ratioB": "Verhältnis B",
        "ratioBHint": "Teil B der Mischung (z. B.: 1)",
        "waitBetweenCoats": "Wartezeit zwischen Schichten"
      },
      "substratePrep": {
        "title": "Untergrundvorbereitung",
        "crackTreatment": "Rissbehandlung",
        "dustRemoval": "Entstaubung",
        "inspection": "Untergrundinspektion",
        "jointTreatment": "Fugenbehandlung",
        "maskingProtection": "Schutz angrenzender Bereiche",
        "maxImperfectionHint": "Schwellenwert, ab dem eine Füllaufgabe generiert wird",
        "maxImperfectionMm": "Max. Unebenheit",
        "sanding": "Schleifen",
        "surfaceCleaning": "Oberflächenreinigung"
      },
      "taskFamilies": {
        "title": "Aktivierung der Aufgabenfamilien",
        "description": "Das Deaktivieren einer Familie verhindert, dass diese Aufgaben in neuen Projekten generiert werden. Bestehende Aufgaben werden nicht gelöscht.",
        "aftercare": "Aftercare / Schutz",
        "coating": "Finishschichten",
        "drying": "Trocknungszeit",
        "handover": "Kundenübergabe (Handover)",
        "heavyDuty": "Heavy-Duty Sealer",
        "mesh": "Mesh / Gewebe",
        "preparation": "Untergrundvorbereitung",
        "presealer": "Presealer",
        "primer": "Primer",
        "qualityControl": "Qualitätskontrolle",
        "sealer": "Sealer"
      },
      "underfloorHeating": {
        "title": "Fußbodenheizung",
        "clientWarningRapidHeatUp": "Kundenwarnung schnelles Aufheizen",
        "controlsTitle": "Kontrollen",
        "dailyTempCheck": "Tägliche Temperaturkontrolle",
        "floorSurfaceTempCheck": "Bodentemperaturkontrolle vor Neustart",
        "generateClientHandover": "Anweisungen an Kunden übergeben",
        "generateMonitoring": "Temperaturkontroll-Aufgaben",
        "generateProgressiveHeatUp": "Progressives Aufheizen (Aufgaben pro Tag)",
        "generateRestart": "Heizungs-Neustart-Aufgaben",
        "generateShutdown": "Heizungsabschalt-Aufgabe",
        "generateTasks": "Fußbodenheizungs-Aufgaben generieren",
        "generationTitle": "Generierung",
        "offDuringApplication": "Heizung während Anwendung ausgeschaltet",
        "offDuringCure": "Heizung während Aushärtung ausgeschaltet",
        "requireQuestion": "Heizungsfrage für Bodenabschnitte stellen",
        "restartAfterSealer": "Wartezeit nach Versiegelung vor Neustart",
        "restartCompletionQc": "Abschluss-QC nach Neustart",
        "restartMaxTemp": "Maximale Temperatur",
        "restartMinDuration": "Mindestanstiegsdauer",
        "restartRequiresValidation": "Validierung am Ende erforderlich",
        "restartStartTemp": "Starttemperatur",
        "restartTempIncrement": "Tagesinkrement",
        "restartTitle": "Progressiver Neustart",
        "shutdownBeforeApplication": "Abschaltstunden vor Anwendung",
        "shutdownBeforeSealer": "Abschaltstunden vor Versiegelung",
        "shutdownTitle": "Abschaltung vor Anwendung",
        "warning": "Das Ändern der Neustart-Parameter kann die Leistung des Belags beeinflussen. Ändern Sie diese Werte nur gemäß der technischen Dokumentation von Mas Maya."
      },
      "waterproofing": {
        "title": "Abdichtung",
        "bathrooms": "Membran erforderlich — Badezimmer",
        "description": "Die Mas Maya Beschichtung ist wasserbeständig, aber nicht abdichtend. Eine Abdichtungsmembran ist in folgenden Fällen erforderlich.",
        "pools": "Membran erforderlich — Schwimmbäder",
        "wetZones": "Membran erforderlich — Nassbereiche",
        "wetZonesHint": "Nassbereiche, direkte Wassereinwirkung"
      }
    },
    "roomCalculation": {
      "title": "Raumberechnung",
      "subtitle": "Koeffizienten und Parameter für die Flächenberechnung von Raum-Abschnitten",
      "resetTitle": "Parameter zurücksetzen",
      "resetConfirm": "Alle Werte werden durch Standardwerte ersetzt. Diese Aktion ist nicht rückgängig zu machen.",
      "surfaceCoefficients": {
        "title": "Flächenkoeffizienten",
        "subtitle": "Multiplikatoren für die Bodenflächenberechnung der Materialmengen",
        "walls": "Wände",
        "wallsFormula": "Wandfläche = Boden_m² × (Höhenkoeff − Deckenkoeff)",
        "wallsNote": "Der Wandkoeffizient wird automatisch aus den Höhen- und Deckenkoeffizienten abgeleitet.",
        "floorCoeff": "Bodenkoeffizient",
        "floorCoeffDesc": "Bodenflächen-Multiplikator (Standard = 1)",
        "ceilingCoeff": "Deckenkoeffizient",
        "ceilingCoeffDesc": "Deckenflächen-Multiplikator (Standard = 1)"
      },
      "calculationMode": {
        "title": "Standardberechnungsmodus",
        "label": "Berechnungsmethode",
        "description": "Standardmäßig verwendeter Modus bei der Erstellung eines Raum-Abschnitts",
        "method1": "Methode 1 — Schnellkoeffizient",
        "method2": "Methode 2 — Exakte Abmessungen",
        "method3": "Methode 3 — Premium angepasst"
      },
      "heightCoefficients": {
        "title": "Höhenkoeffizienten",
        "subtitle": "Globaler Flächenkoeffizient = Boden_m² × Koeffizient (Schnellmethode)"
      },
      "geometricMultipliers": {
        "title": "Geometrische Multiplikatoren",
        "subtitle": "Anpassungsfaktoren nach Raumtyp",
        "colType": "Typ",
        "colLabel": "Bezeichnung",
        "colMin": "Min",
        "colDefault": "Standard",
        "colMax": "Max"
      },
      "openingDeductions": {
        "title": "Abzugsregeln für Öffnungen",
        "standardDoors": "Standardtüren abziehen",
        "standardWindows": "Standardfenster abziehen",
        "largeBays": "Große Fensterfronten abziehen",
        "shopfronts": "Schaufenster abziehen",
        "largeGlassPartitions": "Große Glaswände abziehen",
        "thresholdLabel": "Abzugsschwelle für große Öffnungen (m²)",
        "thresholdDesc": "Öffnungen über diesem Schwellenwert werden abgezogen, wenn die entsprechende Regel aktiviert ist"
      },
      "detailAdditions": {
        "title": "Detailzuschläge",
        "subtitle": "Zuschlagsprozentsatz für architektonische Details (Rücksprünge, Nischen, Balken, Kassetten, Pfeiler…)",
        "min": "Mindestzuschlag (%)",
        "default": "Standardzuschlag (%)",
        "max": "Höchstzuschlag (%)"
      },
      "siteConditions": {
        "title": "Baustellenzustands-Multiplikatoren",
        "subtitle": "Zuschläge basierend auf dem Belegungsstatus der Baustelle",
        "occupied": "Besetzte / möblierte Baustelle",
        "luxury": "Luxus- / Ultra-Premium-Baustelle",
        "minimum": "Minimum (%)",
        "maximum": "Maximum (%)"
      },
      "heightAccess": {
        "title": "Höhen-/Zugangsmultiplikatoren",
        "subtitle": "Zuschläge basierend auf der Deckenhöhe (Zugang, Gerüst)",
        "standardHeight": "Standardhöhe (0%)",
        "noAddition": "0% — kein Zuschlag"
      },
      "specialFormulas": {
        "title": "Spezielle geometrische Formeln",
        "beams": "Balken",
        "beamsFormula": "Fläche = Länge × Σ sichtbare Seiten",
        "beamsNote": "Jede sichtbare Seite (Unterseite, Seiten) × Länge addieren",
        "pillars": "Pfeiler",
        "pillarsFormula": "Fläche = Umfang × Höhe",
        "pillarsNote": "Umfang = Summe der exponierten Seiten",
        "slopedCeilings": "Geneigte / schräge Decken",
        "slopedCeilingsFormula": "tatsächliche Fläche = projizierte Fläche / cos(Winkel)",
        "slopedCeilingsNote": "Winkel wird von der Horizontalen gemessen",
        "niches": "Nischen",
        "nichesFormula": "Rückwand + linke Seite + rechte Seite + oben + unten + Rücksprünge",
        "nichesNote": "Jede Seite einzeln eingeben"
      }
    },
    "milestoneWorkflowDesigner": {
      "title": "Workflow Designer",
      "subtitle": "Konfigurieren Sie den Standard-Meilensteinpfad für jedes neue Projekt.",
      "addMilestone": "Meilenstein hinzufügen",
      "saveMilestone": "Speichern",
      "delete": "Löschen",
      "unsavedChanges": "Ungespeicherte Änderungen",
      "sections": {
        "identity": "Identität",
        "triggerEngine": "Auslöse-Engine",
        "clientVisibility": "Kundensichtbarkeit",
        "approvalGate": "Genehmigungsschranke",
        "payment": "Zahlung",
        "applicability": "Anwendbarkeit",
        "photoRules": "Fotoregeln",
        "automation": "Automatisierung",
        "notifications": "Benachrichtigungen"
      },
      "fields": {
        "customTitle": "Benutzerdefinierter Titel",
        "color": "Farbe",
        "icon": "Symbol",
        "type": "Typ",
        "scope": "Bereich",
        "triggerType": "Auslöser",
        "triggerCategories": "Auslösekategorien",
        "blocksCategories": "Gesperrte Kategorien",
        "isVisibleToClient": "Für Kunden sichtbar",
        "notifyClient": "Kunden benachrichtigen",
        "showPhotosToClient": "Fotos dem Kunden zeigen",
        "showProgress": "Fortschritt anzeigen",
        "requiresClientApproval": "Kundengenehmigung erforderlich",
        "paymentType": "Zahlungsart",
        "paymentPercent": "Prozentsatz (%)",
        "paymentAmount": "Betrag (€)",
        "appliesToRenovation": "Renovierung",
        "appliesToNewBuild": "Neubau",
        "appliesToExternalOnly": "DIY / Extern",
        "appliesToManaged": "Mas Maya Verwaltet",
        "appliesToExecuted": "Mas Maya Ausgeführt",
        "requirePhotos": "Fotos erforderlich",
        "minPhotos": "Mindestfotos",
        "photosVisibleToClient": "Fotos für Kunden sichtbar",
        "autoComplete": "Automatisch abschließen",
        "autoNotifyClient": "Kunden automatisch benachrichtigen",
        "autoLockDependentTasks": "Abhängige Aufgaben sperren",
        "autoUnlockAfterApproval": "Nach Genehmigung entsperren",
        "notifyWorker": "Mitarbeiter benachrichtigen",
        "notifyQm": "QM benachrichtigen",
        "notifyPm": "PM benachrichtigen"
      },
      "types": {
        "Progress": "Fortschritt",
        "Approval": "Genehmigung",
        "Payment": "Zahlung"
      },
      "scopes": {
        "Project": "Projekt",
        "Section": "Abschnitt"
      },
      "triggerTypes": {
        "AllCategoriesCompleted": "Alle Kategorien abgeschlossen",
        "FirstTaskStarted": "Erste Aufgabe gestartet",
        "ProjectArchived": "Projekt archiviert",
        "Manual": "Manuell"
      },
      "paymentTypes": {
        "None": "Keine",
        "Percent": "Prozentsatz",
        "Fixed": "Festbetrag"
      },
      "categories": {
        "preparation": "Vorbereitung",
        "primer": "Grundierung",
        "mesh": "Gewebe",
        "baseLayer": "Grundschicht",
        "finishingLayer": "Deckschicht",
        "smoothing": "Glättung",
        "presealer": "Vorversiegler",
        "sealer": "Versiegler",
        "heavyDutySealer": "Heavy-Duty Versiegler",
        "curing": "Aushärtung",
        "delivery": "Lieferung",
        "inspection": "Inspektion",
        "handover": "Übergabe",
        "custom": "Benutzerdefiniert"
      },
      "executionModes": {
        "externalOnly": "DIY / Extern",
        "managed": "Mas Maya Verwaltet",
        "executed": "Mas Maya Ausgeführt"
      },
      "projectTypes": {
        "renovation": "Renovierung",
        "newBuild": "Neubau"
      }
    },
    "milestoneTemplateConfig": {
      "title": "Meilenstein-Vorlagen",
      "description": "Diese Einstellungen definieren die Meilensteine, die automatisch für jedes neue Mas Maya-Projekt erstellt werden.",
      "projectMilestones": "Projekt-Meilensteine",
      "sectionMilestones": "Meilensteine pro Fläche",
      "save": "Speichern",
      "saveSuccess": "Konfiguration gespeichert.",
      "saveError": "Fehler beim Speichern.",
      "unsavedWarning": "Es gibt ungespeicherte Änderungen.",
      "m1": {
        "label": "Projekt gestartet",
        "hint": "Automatisch abgeschlossen, wenn die erste Aufgabe gestartet wird."
      },
      "m2": {
        "label": "Vorbereitung abgeschlossen",
        "hint": "Abgeschlossen, wenn alle Vorbereitungs- und Grundieraufgaben erledigt sind."
      },
      "m3": {
        "label": "Flächengenehmigung",
        "hint": "Wird pro Abschnitt ausgelöst, wenn die Deckschichten fertig sind.",
        "requiresClientApproval": "Kundengenehmigung erforderlich",
        "requiresClientApprovalHint": "Der Kunde erhält einen eindeutigen Link, um jede Fläche zu genehmigen oder abzulehnen."
      },
      "m4": {
        "label": "Schutz abgeschlossen",
        "hint": "Abgeschlossen, wenn alle Vorversiegler-, Versiegler- und Schwerlastversiegler-Aufgaben erledigt sind."
      },
      "m5": {
        "label": "Lieferung",
        "hint": "Automatisch abgeschlossen, wenn das Projekt archiviert wird.",
        "paymentType": "Zahlungsart",
        "paymentNone": "Keine",
        "paymentPercent": "Prozentsatz",
        "paymentFixed": "Festbetrag",
        "paymentPercentLabel": "Prozentsatz (%)",
        "paymentAmountLabel": "Betrag (€)"
      }
    }
  },
  "cart": {
    "title": "Warenkorb",
    "empty": "Der Warenkorb ist leer",
    "clear": "Warenkorb leeren",
    "clearTitle": "Warenkorb leeren",
    "clearConfirm": "Alle Artikel aus dem Warenkorb entfernen?",
    "clearAction": "Leeren",
    "training": "Schulung",
    "subtotal": "Zwischensumme",
    "discount": "Rabatt",
    "total": "Gesamt",
    "columns": {
      "item": "Artikel",
      "unitPrice": "Einzelpreis",
      "qty": "Menge",
      "total": "Gesamt"
    },
    "discountReason": {
      "base": "Grundtarif",
      "manual_override": "Manueller Admin-Rabatt",
      "cart_training_incentive": "Durch Schulung freigeschaltet",
      "certification_Basic": "Basic-Zertifizierung",
      "certification_Intermediate": "Mittelstufen-Zertifizierung",
      "certification_Expert": "Experten-Zertifizierung",
      "certification_ExpertFinishes": "Experten-Oberflächen-Zertifizierung"
    },
    "upsell": {
      "title": "Rabatt freischalten",
      "addTraining": "{{title}} zum Warenkorb hinzufügen",
      "level": {
        "Basic": "Basic",
        "Intermediate": "Mittelstufe",
        "Expert": "Experte",
        "ExpertFinishes": "Experte Oberflächen"
      }
    }
  },
  "staff": {
    "title": "Personal",
    "createButton": "Neues Mitglied",
    "createTitle": "Mitglied hinzufügen",
    "noData": "Keine Mitglieder gefunden",
    "showInactive": "Inaktive anzeigen",
    "manager": "Verantwortlicher",
    "setManager": "Zum Verantwortlichen ernennen",
    "removeManager": "Verantwortlichen-Rolle entfernen",
    "managers": "Verantwortliche",
    "activate": "Aktivieren",
    "deactivate": "Deaktivieren",
    "columns": {
      "name": "Name",
      "email": "E-Mail",
      "status": "Status",
      "manager": "Manager"
    },
    "status": {
      "active": "Aktiv",
      "inactive": "Inaktiv"
    },
    "sections": {
      "profile": "Profil"
    },
    "teaching": {
      "title": "Lehrerzertifizierung",
      "becomeTeacher": "Dieser Mitarbeiter ist auch Lehrer",
      "certifyTitle": "Als Lehrer zertifizieren",
      "editTitle": "Zertifizierung bearbeiten",
      "editCertification": "Zertifizierung bearbeiten"
    },
    "schedule": {
      "title": "Planung",
      "date": "Datum",
      "startTime": "Startzeit",
      "endTime": "Endzeit",
      "type": "Typ",
      "project": "Projekt",
      "notes": "Notizen",
      "addEntry": "Eintrag hinzufügen",
      "empty": "Keine Planungseinträge",
      "removeTitle": "Eintrag entfernen",
      "removeConfirm": "Möchten Sie diesen Planungseintrag wirklich entfernen?"
    },
    "scheduleType": {
      "ProjectAssignment": "Projektzuweisung",
      "TrainingSession": "Schulungssitzung",
      "Unavailable": "Nicht verfügbar"
    },
    "assignedProjects": "Zugewiesene Projekte",
    "noAssignedProjects": "Keine zugewiesenen Projekte",
    "rolePM": "Projektleiter",
    "roleBackupPM": "Stellv. Projektleiter",
    "form": {
      "notes": "Notizen",
      "firstName": "Vorname",
      "firstNamePlaceholder": "Johann",
      "lastName": "Nachname",
      "lastNamePlaceholder": "Müller",
      "emailRequired": "E-Mail ist erforderlich",
      "firstNameRequired": "Vorname ist erforderlich",
      "lastNameRequired": "Nachname ist erforderlich",
      "email": "E-Mail"
    }
  },
  "structures": {
    "title": "Struktur",
    "type": "Strukturtyp",
    "noStructure": "Keine Struktur definiert",
    "define": "Struktur definieren",
    "computedSurface": "Berechnete Fläche",
    "computedVolume": "Berechnetes Volumen",
    "deleteTitle": "Struktur löschen",
    "deleteConfirm": "Die Strukturdefinition für diesen Abschnitt löschen? Die Fläche wird nicht neu berechnet."
  },
  "calendar": {
    "title": "Kalender",
    "mode": {
      "project": "Nach Projekt",
      "staff": "Nach Mitarbeiter"
    },
    "labels": {
      "today": "Heute",
      "day": "Tag",
      "week": "Woche",
      "month": "Monat",
      "year": "Jahr"
    },
    "filters": {
      "categories": "Anzeigen",
      "allProjects": "Alle Projekte",
      "selectProject": "Projekt auswählen",
      "selectStaff": "Mitarbeiter auswählen",
      "allStatuses": "Alle Status",
      "allStepTypes": "Alle Schritttypen",
      "allStaff": "Alle Mitarbeiter",
      "allAccounts": "Alle Konten"
    },
    "categories": {
      "ProjectStep": "Projektschritt",
      "DryingPeriod": "Trocknungszeit",
      "CuringPeriod": "Aushärtezeit",
      "Delivery": "Lieferung",
      "Training": "Schulung",
      "StaffSchedule": "Teamplan",
      "Supervision": "Aufsicht",
      "Personal": "Persönlich",
      "ProjectTask": "Projektaufgabe"
    },
    "taskStatuses": {
      "Todo": "Offen",
      "InProgress": "In Bearbeitung",
      "SubmittedForReview": "Zur Prüfung eingereicht",
      "ValidatedAsTechnicallyCompliant": "Validiert",
      "RejectedWithCorrectionRequired": "Abgelehnt — Korrektur erforderlich",
      "Blocked": "Blockiert"
    },
    "taskCategories": {
      "Preparation": "Vorbereitung",
      "Primer": "Grundierung",
      "Mesh": "Armierung",
      "BaseLayer": "Basisschicht",
      "FinishingLayer": "Deckschicht",
      "Smoothing": "Glätten",
      "Presealer": "Vorversiegelung",
      "Sealer": "Versiegelung",
      "HeavyDutySealer": "Verstärkte Versiegelung",
      "Curing": "Aushärtung",
      "Delivery": "Lieferung",
      "Inspection": "Inspektion",
      "Handover": "Übergabe",
      "Custom": "Benutzerdefiniert"
    },
    "taskPriorities": {
      "Low": "Niedrig",
      "Normal": "Normal",
      "High": "Hoch",
      "Critical": "Kritisch"
    },
    "stepTypes": {
      "SubstratePreparation": "Untergrundvorbereitung",
      "PrimerApplication": "Grundierung",
      "BaseLayer": "Grundschicht",
      "MeshInstallation": "Gewebeeinlage",
      "FinishingCoat": "Deckschicht",
      "Smoothing": "Glätten / Schleifen",
      "Presealer": "Vorversiegelung",
      "Sealer": "Versiegelung",
      "HeavyDutySealer": "Hochleistungsversiegelung",
      "CuringStep": "Aushärtung",
      "ProtectionPeriod": "Schutzphase",
      "Handover": "Übergabe"
    },
    "stepStatuses": {
      "Planned": "Geplant",
      "InProgress": "In Bearbeitung",
      "Completed": "Abgeschlossen",
      "Blocked": "Blockiert",
      "ValidationPending": "Validierung ausstehend",
      "CorrectionRequired": "Korrektur erforderlich",
      "Cancelled": "Abgebrochen"
    },
    "deliveryTypes": {
      "OrderConfirmed": "Bestellung bestätigt",
      "OrderPrepared": "Bestellung vorbereitet",
      "DeliveryExpected": "Lieferung erwartet",
      "DeliveryDelayed": "Lieferung verzögert",
      "DeliveryCompleted": "Geliefert"
    },
    "deliveryStatuses": {
      "Pending": "Ausstehend",
      "InTransit": "Unterwegs",
      "Delivered": "Geliefert",
      "Delayed": "Verzögert",
      "Cancelled": "Abgebrochen"
    },
    "scheduleEntryTypes": {
      "ProjectAssignment": "Projektzuteilung",
      "TrainingSession": "Schulungssitzung",
      "Unavailable": "Nicht verfügbar"
    },
    "detail": {
      "start": "Beginn",
      "end": "Ende",
      "project": "Projekt",
      "section": "Abschnitt",
      "stepType": "Schritttyp",
      "status": "Status",
      "blocked": "Blockiert",
      "drying": "Trocknungszeit",
      "curing": "Aushärtezeit",
      "deliveryType": "Lieferungstyp",
      "deliveryStatus": "Lieferstatus",
      "trackingNumber": "Sendungsnummer",
      "carrier": "Spediteur",
      "location": "Ort",
      "staffMember": "Teammitglied",
      "entryType": "Eintragstyp",
      "notes": "Anmerkungen",
      "deleteConfirm": "Möchten Sie dieses Ereignis wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "taskStatus": "Status",
      "taskCategory": "Kategorie",
      "taskPriority": "Priorität",
      "assignedApplicator": "Applikateur",
      "assignedManager": "Projektleiter",
      "validationRequired": "Validierung erforderlich",
      "noPlannedDate": "Kein geplantes Datum — am Projektstartdatum platziert"
    },
    "modal": {
      "createStep": "Projektschritt erstellen",
      "editStep": "Projektschritt bearbeiten",
      "createDelivery": "Lieferung erstellen",
      "editDelivery": "Lieferung bearbeiten",
      "project": "Projekt",
      "stepType": "Schritttyp",
      "customTitle": "Benutzerdefinierter Titel",
      "customTitlePlaceholder": "Leer lassen für automatischen Typnamen",
      "date": "Datum",
      "startTime": "Startzeit",
      "endTime": "Endzeit",
      "dryingHours": "Trocknung (Stunden)",
      "curingHours": "Aushärtung (Stunden)",
      "status": "Status",
      "notes": "Anmerkungen",
      "isBlocked": "Blockiert",
      "blockedReason": "Blockierungsgrund",
      "deliveryType": "Lieferungstyp",
      "deliveryStatus": "Status",
      "expectedDate": "Erwartetes Datum",
      "actualDate": "Tatsächliches Lieferdatum",
      "trackingNumber": "Sendungsnummer",
      "carrier": "Spediteur"
    }
  },
  "supervision": {
    "title": "Überwachung",
    "tabs": {
      "comments": "Kommentare",
      "observations": "Beobachtungen",
      "escalations": "Eskalationen",
      "history": "Verlauf"
    },
    "visibility": {
      "label": "Sichtbarkeit",
      "ClientVisible": "Für Kunden sichtbar",
      "TeamVisible": "Nur Team",
      "InternalOnly": "Nur intern"
    },
    "comments": {
      "empty": "Noch keine Kommentare.",
      "newPlaceholder": "Kommentar schreiben…",
      "replyPlaceholder": "Antwort schreiben…",
      "send": "Senden",
      "reply": "Antworten",
      "deleted": "[gelöscht]"
    },
    "observations": {
      "empty": "Keine Beobachtungen.",
      "open": "offen",
      "resolvedCount": "gelöst",
      "add": "Beobachtung hinzufügen",
      "titleLabel": "Titel",
      "bodyLabel": "Beschreibung",
      "severityLabel": "Schweregrad",
      "by": "von",
      "resolved": "Gelöst",
      "resolve": "Als gelöst markieren",
      "confirmResolve": "Bestätigen",
      "resolutionNote": "Lösungshinweis",
      "resolveNotePlaceholder": "Beschreiben Sie die Lösung…",
      "severity": {
        "Info": "Info",
        "Warning": "Warnung",
        "Critical": "Kritisch"
      }
    },
    "escalations": {
      "empty": "Keine Eskalationen.",
      "open": "offen",
      "resolvedCount": "gelöst",
      "new": "Neue Eskalation",
      "subjectLabel": "Betreff",
      "bodyLabel": "Beschreibung",
      "submit": "Einreichen",
      "by": "von",
      "assignedTo": "Zugewiesen an",
      "resolution": "Lösung",
      "resolutionLabel": "Lösungshinweis",
      "statusLabel": "Neuer Status",
      "updateStatus": "Status aktualisieren",
      "status": {
        "Open": "Offen",
        "Acknowledged": "Bestätigt",
        "Resolved": "Gelöst"
      }
    },
    "auditLog": {
      "empty": "Noch keine Aktivität.",
      "loadMore": "Mehr laden",
      "actions": {
        "ProjectCreated": "hat das Projekt erstellt",
        "ProjectUpdated": "hat das Projekt aktualisiert",
        "ProjectStatusChanged": "hat den Projektstatus geändert",
        "ProjectDeleted": "hat das Projekt gelöscht",
        "StepCreated": "hat einen Schritt erstellt",
        "StepUpdated": "hat einen Schritt aktualisiert",
        "StepStatusChanged": "hat den Schrittsstatus geändert",
        "StepDeleted": "hat einen Schritt gelöscht",
        "StepBlocked": "hat einen Schritt blockiert",
        "StepUnblocked": "hat einen Schritt entsperrt",
        "StepValidated": "hat einen Schritt validiert",
        "StepRejected": "hat einen Schritt abgelehnt",
        "DeliveryCreated": "hat eine Lieferung erstellt",
        "DeliveryUpdated": "hat eine Lieferung aktualisiert",
        "DeliveryStatusChanged": "hat den Lieferstatus geändert",
        "DeliveryDeleted": "hat eine Lieferung gelöscht",
        "ApplicatorAssigned": "hat einen Anwender zugewiesen",
        "ApplicatorRemoved": "hat einen Anwender entfernt",
        "TeamMemberAssigned": "hat ein Teammitglied zugewiesen",
        "TeamMemberRemoved": "hat ein Teammitglied entfernt",
        "BackupPmAssigned": "hat einen Stellvertreter-PM zugewiesen",
        "ClientLinked": "hat einen Kunden verknüpft",
        "DocumentUploaded": "hat ein Dokument hochgeladen",
        "DocumentDeleted": "hat ein Dokument gelöscht",
        "CommentAdded": "hat einen Kommentar hinzugefügt",
        "CommentDeleted": "hat einen Kommentar gelöscht",
        "ObservationAdded": "hat eine Beobachtung aufgezeichnet",
        "ObservationResolved": "hat eine Beobachtung gelöst",
        "EscalationCreated": "hat eine Eskalation erstellt",
        "EscalationAcknowledged": "hat eine Eskalation bestätigt",
        "EscalationResolved": "hat eine Eskalation gelöst"
      }
    }
  },
  "roles": {
    "GlobalAdmin": "Super Admin",
    "Admin": "Administrator",
    "ProjectManager": "Projektleiter",
    "BackupProjectManager": "Stellvertretender Projektleiter",
    "MasMayaApplicator": "Mas Maya Applikator",
    "ReferencedInstaller": "Referenzierter Installateur",
    "IndividualClient": "Privatkunde",
    "ProfessionalClient": "Geschäftskunde"
  },
  "userManagement": {
    "title": "Benutzerverwaltung",
    "users": "Benutzer",
    "searchPlaceholder": "Nach Name oder E-Mail suchen…",
    "noRoles": "Keine Rollen zugewiesen",
    "noUsers": "Keine Benutzer gefunden",
    "addRole": "Rolle hinzufügen",
    "impersonate": "Annehmen",
    "impersonatingAs": "Angemeldet als {{name}}",
    "stopImpersonating": "Annehmen beenden",
    "columns": {
      "user": "Benutzer",
      "roles": "Rollen",
      "entities": "Unternehmen"
    },
    "removeRole": {
      "title": "Rolle entfernen",
      "confirm": "Rolle {{role}} von {{user}} entfernen?"
    }
  },
  "shop": {
    "nav": "Shop",
    "hero": {
      "title": "Beschichtungssysteme",
      "subtitle": "Putze, Grundierungen & Zubehör",
      "description": "Architektonische Oberflächenmaterialien für anspruchsvolle Handwerker."
    },
    "allProducts": "Alle Produkte",
    "searchPlaceholder": "Produkte suchen...",
    "noResults": "Keine Produkte gefunden",
    "filterBy": "Filtern nach",
    "sortBy": "Sortieren nach",
    "sort": {
      "nameAsc": "Name (A–Z)",
      "priceAsc": "Preis aufsteigend",
      "priceDesc": "Preis absteigend"
    },
    "addToCart": "In den Warenkorb",
    "addedToCart": "Hinzugefügt",
    "viewDetails": "Produkt ansehen",
    "backToShop": "Zurück zum Shop",
    "relatedProducts": "Ergänzende Produkte",
    "systemNote": "Diese Produkte sind Teil eines vollständigen Anwendungssystems.",
    "selectContact": "Kunden auswählen",
    "selectContactHint": "Wählen Sie einen Kunden aus, um dessen Warenkorb zu verwalten.",
    "cartFor": "Warenkorb für",
    "openCart": "Warenkorb ansehen",
    "cart": {
      "title": "Warenkorb",
      "empty": "Der Warenkorb ist leer.",
      "checkout": "Zur Kasse",
      "orderOnMasmaya": "Auf masmaya.com bestellen"
    },
    "qty": "Menge",
    "details": {
      "category": "Kategorie",
      "variant": "Variante",
      "color": "Farbe",
      "sizeWeight": "Größe / Gewicht",
      "dimensions": "Abmessungen",
      "sku": "Referenz",
      "price": "Preis",
      "technical": "Technische Informationen"
    }
  },
  "applicatorProfiles": {
    "title": "Applikateur-Profile",
    "createTitle": "Applikateur-Profil erstellen",
    "moderateTitle": "Portfolio-Eintrag moderieren",
    "form": {
      "contactId": "Kontakt-ID",
      "contactIdPlaceholder": "Kontakt-UUID einfügen",
      "contactIdRequired": "Kontakt-ID ist erforderlich",
      "displayName": "Anzeigename",
      "displayNameRequired": "Anzeigename ist erforderlich",
      "companyName": "Unternehmensname",
      "bio": "Biografie",
      "city": "Stadt",
      "country": "Land (2-stelliger Code)",
      "travelRadius": "Reiseradius (km)",
      "yearsExperience": "Jahre Erfahrung",
      "availability": "Verfügbarkeit",
      "specialties": "Spezialitäten",
      "styleTags": "Stil-Tags",
      "technicalTags": "Technische Systeme",
      "note": "Hinweis (nur für Admin sichtbar)",
      "newStatus": "Neuer Status"
    },
    "availability": {
      "Available": "Verfügbar",
      "PartiallyBooked": "Teilweise gebucht",
      "Unavailable": "Nicht verfügbar"
    },
    "moderation": {
      "PendingReview": "Ausstehende Prüfung",
      "Approved": "Genehmigt",
      "Rejected": "Abgelehnt",
      "Hidden": "Versteckt",
      "Featured": "Hervorgehoben"
    },
    "currentStatus": "Aktueller Status:",
    "deleteConfirm": "Dieses Applikateur-Profil löschen?",
    "deleteTitle": "Profil löschen"
  }
}
